// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:52:20.961Z
// Property: The Ritz Classic (ID: 6286356741357568)
// Collections: 40 amenities, 9 floorplans (live), 25 photos, 41 POIs, 2 reviews, 6 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6286356741357568",
  "property_external_id": "848354",
  "property_zillow_url": "https://www.zillow.com/apartments/salt-lake-city-ut/the-ritz-classic/9TQJYY/",
  "property_apartments_url": "https://www.apartments.com/the-ritz-classic-salt-lake-city-ut/5ngcw5m",
  "property_google_business_url": "https://www.google.com/maps/place/Ritz+Classic+Apartment+Homes/data=!4m2!3m1!1s0x0:0x9fc654873ab1c8ff?sa=X&ved=2ahUKEwiHwfTNpLmSAxXaw_ACHRIGE9QQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-ritz-classic",
  "property_name": "The Ritz Classic",
  "property_website_url": "https://www.theritzclassic.com/",
  "property_domain": "https://www.theritzclassic.com/",
  "property_address": "2265 State Street",
  "property_full_address": "2265 S State St, Salt Lake City, UT 84115",
  "property_address_1": "2265 S State St",
  "property_address_2": null,
  "property_address_city": "Salt Lake City",
  "property_address_state": "UT",
  "property_address_zip_full": "84115",
  "property_address_zip": "84115",
  "property_address_country": "US",
  "property_address_county": "Salt Lake County",
  "property_neighborhood_address": "South Salt Lake City",
  "property_address_latitude": "40.7214738",
  "property_address_longitude": "-111.8863994",
  "property_email": "ritz@weidner.com",
  "property_phone": "(385) 355-3605",
  "property_call_tracking_phone": "801-797-0504",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover upscale living at The Ritz Classic in Salt Lake City, UT, with versatile floor plans—from studios to two-bedroom apartments. Enjoy amenities like a yoga studio, coffee bar, pet play area, and more. Find your new home today—browse our availability or schedule a tour to visit our vibrant community!",
  "property_long_description": "Welcome to The Ritz Classic, where contemporary living meets classic elegance in the heart of Salt Lake City, UT. Our thoughtfully designed apartment community offers a variety of spacious floor plans, including cozy studios, inviting one-bedroom, and expansive two-bedroom apartments, tailored to suit your lifestyle. Each residence features modern amenities like granite countertops and, for those who desire extra convenience, select units come furnished and with pantry space available*. \n\nAt The Ritz Classic, we believe in enhancing your living experience with top-notch community amenities. Start your day at our energizing yoga studio, unwind at our communal coffee bar, or enjoy some quality time with your furry companions at our pet play area and dog park. Outdoor enthusiasts will love our bocce ball court, while eco-conscious residents appreciate our electric car charging stations. \n\nOur dedicated bilingual leasing team is here to assist you every step of the way, ensuring your transition into your new home is seamless and enjoyable. The Ritz Classic is the perfect place to blend comfort, community, and style in a vibrant and accessible location. \n\nFind your new home today—browse our availability or schedule a tour to visit our exceptional community! Experience the lifestyle you deserve at The Ritz Classic, where every detail is designed with you in mind.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13282-d29c-713d-b2d6-e865e7f9a316.webp",
  "property_featured_image_media": {
    "alt_text": "Lobby area with a modern fireplace and abstract art",
    "public_id": "01a13282-d29c-713d-b2d6-e865e7f9a316",
    "storage_key": "property/6286356741357568/01a13282-d29c-713d-b2d6-e865e7f9a316.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "287",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.81881533101046",
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security deposit: $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "45",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://theritzclassic.securecafe.com/onlineleasing/the-ritz-classic/floorplans.aspx",
  "property_resident_portal_url": "https://theritzclassic.securecafenet.com/residentservices/the-ritz-classic/userlogin",
  "property_apply_now_url": "https://theritzclassic.securecafe.com/onlineleasing/the-ritz-classic/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a5-588b-73a2-9579-a6e0d5095f96.webp",
  "property_primary_logo_media": {
    "alt_text": "Ritz Classic logo",
    "public_id": "019d01a5-588b-73a2-9579-a6e0d5095f96",
    "storage_key": "property/6286356741357568/019d01a5-588b-73a2-9579-a6e0d5095f96.webp",
    "width": 92,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a5-44dc-716e-a165-192f717de06d.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01a5-44dc-716e-a165-192f717de06d",
    "storage_key": "property/6286356741357568/019d01a5-44dc-716e-a165-192f717de06d.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a5-588b-73a2-9579-a6e0d5095f96.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Ritz Classic logo",
    "public_id": "019d01a5-588b-73a2-9579-a6e0d5095f96",
    "storage_key": "property/6286356741357568/019d01a5-588b-73a2-9579-a6e0d5095f96.webp",
    "width": 92,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a5-6208-719b-abbe-f7e9b5c84687.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Ritz Classic logo",
    "public_id": "019d01a5-6208-719b-abbe-f7e9b5c84687",
    "storage_key": "property/6286356741357568/019d01a5-6208-719b-abbe-f7e9b5c84687.webp",
    "width": 92,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#0e284a",
  "property_secondary_color": "#96c848",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1074",
  "property_sqft_min": "497",
  "property_sqft_max": "1074",
  "property_price_range": "1044 - 3365",
  "property_price_min": "1130",
  "property_price_max": "3025",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/groups/saltlakehistory/posts/1391015481067428/",
  "property_instagram_url": "https://www.instagram.com/ritzsaltlake/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJlX8kjuSLUocR_8ixOodUxp8",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Ritz Classic",
  "property_home_romance_title": "Embrace Your Dream Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to The Ritz Classic, where modern living meets timeless elegance in Salt Lake City. Our thoughtfully designed floor plans, featuring studios, one, and two bedrooms, are complemented by luxurious amenities like a serene clubhouse, state-of-the-art fitness center, and inviting pet play area. Elevate your lifestyle today!",
  "property_home_floorplans_blurb": "Welcome to The Ritz Classic in the heart of Salt Lake City, UT, where modern living meets timeless elegance. Choose from thoughtfully designed studio, one-bedroom, and two-bedroom apartments, each tailored to complement your lifestyle. Browse our available homes and uncover the perfect floor plan that suits your unique taste.",
  "property_home_gallery_blurb": "At The Ritz Classic in Salt Lake City, your ideal home awaits! Choose from thoughtfully designed studio, one, or two-bedroom floor plans boasting inviting amenities like a fitness center, pool, and pet play area. Picture yourself enjoying stunning mountain views from your balcony or hosting friends by the grill.",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding The Ritz Classic in Salt Lake City, UT! From chic studio apartments to spacious two-bedroom layouts, our community offers the perfect home for every lifestyle. See what's around our community and explore local favorites and nearby points of interest that make living here truly special!",
  "property_home_reviews_blurb": "At The Ritz Classic in Salt Lake City, modern elegance meets welcoming charm. Our residents rave about the spacious, sunlit apartments and an array of luxurious amenities, from a sparkling pool to a vibrant sports lounge. Feel at home with a dedicated team that truly cares—discover why we're at the top of their list!",
  "property_neighborhood_blurb": "At The Ritz Classic in Salt Lake City, experience a vibrant neighborhood teeming with culture and adventure. With nearby gems like the Natural History Museum of Utah, Liberty Park, and the iconic Temple Square, you'll never run out of exciting activities. See what's around our community and uncover local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to The Ritz Classic in Salt Lake City, UT! Discover our diverse floor plans, including studios and one- to two-bedroom apartments. Enjoy amenities like a yoga studio, dog park, and coffee bar. Explore our amazing community features and elevate your living experience today!",
  "property_applynow_blurb": "Discover your ideal living space at The Ritz Classic in Salt Lake City, UT. Choose from studio, one-bedroom, or two-bedroom floor plans, and enjoy amenities like a yoga studio, pet-friendly dog park, and stylish granite countertops. Find your new home and lease online today! ",
  "property_contactus_blurb": "Discover your ideal living space at The Ritz Classic in Salt Lake City, UT. Explore our versatile floor plans, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments. Each design maximizes comfort and style. Have questions? Contact our leasing team today to find your perfect home!",
  "property_faqs_blurb": "Welcome to The Ritz Classic in Salt Lake City, UT! Explore our diverse floor plans, including studio, one-bedroom, and two-bedroom layouts. Have questions? Browse our FAQs page to find answers about our vibrant community and discover why The Ritz Classic is the perfect place to call home!",
  "property_floorplans_blurb": "Discover your ideal living space at The Ritz Classic in Salt Lake City, UT. Choose from our stylish studio, one-bedroom, or spacious two-bedroom floor plans. Each design offers comfort and convenience tailored to your lifestyle. Browse our available apartment homes today and find your perfect floor plan!",
  "property_gallery_blurb": "Discover your dream home at The Ritz Classic in Salt Lake City, UT. Choose from studio, one, or two-bedroom floor plans, featuring granite countertops and pantry options. Enjoy amenities like a yoga studio, pet play area, and electric car charging station. Picture yourself living here—explore our photo gallery today!",
  "property_interactivemap_blurb": "Discover your perfect home at The Ritz Classic in Salt Lake City, UT! Choose from studio, one, or two-bedroom floor plans, and enjoy premium amenities like a yoga studio, pet-friendly parks, and modern granite countertops. Use our interactive community map to explore available apartments and pricing today!",
  "property_pets_blurb": "At The Ritz Classic in Salt Lake City, UT, modern living meets timeless elegance. Our welcoming community features spacious floor plans and luxurious amenities, all just minutes from vibrant city life. With a thoughtful pet policy, your furry friends will feel right at home too! Experience upscale living today.",
  "property_referafriend_blurb": "Discover your ideal living space at The Ritz Classic in Salt Lake City, UT. With stylish studio, one-bedroom, and two-bedroom floor plans, there's something for everyone. Great friends make great neighbors—refer a friend to our community today and enjoy the perks of living together in luxury. View all floor plans now!",
  "property_residentaccess_blurb": "Welcome to The Ritz Classic in Salt Lake City, UT, where comfort meets convenience! Explore our diverse floor plans, including studios, one-bedroom, and two-bedroom apartments. Access your resident portal to easily pay rent, schedule maintenance, and stay connected with your community. Experience upscale living today!",
  "property_reviews_blurb": "At The Ritz Classic in Salt Lake City, our residents rave about the exceptional living experience we offer. With beautifully designed apartments filled with natural light and a welcoming team led by Nils, you’ll find your perfect home here. “For location, amenities, and staff—the Ritz blows their competition out of the water!” Join our vibrant community today!",
  "property_created_at": "1751380862130",
  "property_scheduletour_blurb": "Discover your perfect home at The Ritz Classic in Salt Lake City, UT, featuring a variety of floor plans including stylish studios, spacious one-bedroom, and inviting two-bedroom apartments. Schedule a tour today and see what our residents say about their exceptional living experience in our vibrant community!",
  "property_thankyou_blurb": "Thank you for your interest in The Ritz Classic in Salt Lake City, UT! Explore our diverse floor plans, including spacious studios, one-bedroom, and two-bedroom apartments. A member of our team will reach out shortly to assist you in finding your perfect home. Stay tuned for all the details!",
  "property_virtualtours_blurb": "Explore The Ritz Classic in Salt Lake City, UT, where modern living meets comfort! Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans. Discover your perfect home today—take a virtual tour of our vibrant community and apartments for rent! Experience luxury at your fingertips!",
  "property_copyright": "2025 All Rights Reserved. The Ritz Classic",
  "property_seo_title_home": "The Ritz Classic | Apartments in South Salt Lake City",
  "property_seo_description_home": "The Ritz Classic Apartments: Check out photos, availability, pricing, amenities, and reviews for The Ritz Classic Apartments in Salt Lake City",
  "property_seo_title_floorplans": "Floor Plans | Apartments in Salt Lake City",
  "property_seo_description_floorplans": "View our available studio, one, and two bedroom apartment floorplans for rent at The Ritz Classic today! Find the one that's right for you!",
  "property_seo_title_amenities": "Amenities | The Ritz Classic Apartments",
  "property_seo_description_amenities": "View unit and community amenities for The Ritz Classic Apartments in Utah. Our amenities are modern and stylish like the homes that we provide.",
  "property_seo_title_gallery": "Photo Gallery | The Ritz Classic Apartments",
  "property_seo_description_gallery": "Explore our high-resolution photo gallery to get a sneak peek at The Ritz Classic Apartment in Salt Lake City. See our amenities and community today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Ritz Classic in Salt Lake City, UT",
  "property_seo_description_virtualtours": "Learn more about our apartments for rent at The Ritz Classic Apartment Homes in Salt Lake City, UT and view our community and floorplans!",
  "property_seo_title_interactivemap": "Interactive Map | The Ritz Classic Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at The Ritz Classic in Salt Lake City, UT! Explore our diverse floor plans, including studio, one-bedroom, and two-bedroom options, tailored to fit your lifestyle. Enjoy top-notch amenities such as a yoga studio, coffee bar, pet play area, and more. Plus, our bilingual leasing team is here to assist you! Use our interactive community map to easily search available apartments, view pricing, and find your new sanctuary today!",
  "property_seo_title_neighborhood": "Neighborhood | The Ritz Classic",
  "property_seo_description_neighborhood": "Looking for food, entertainment or more? View the neighborhood surrounding The Ritz Classic Apartments to see what your next community has to offer.",
  "property_seo_title_contact": "Contact Us | The Ritz Classic",
  "property_seo_description_contact": "Learn more about The Ritz Classic Apartments and schedule a visit today. Contact us with any questions or to set up a tour of our community!",
  "property_seo_title_faqs": "FAQs | Apartments in Salt Lake City, UT",
  "property_seo_description_faqs": "Discover The Ritz Classic in Salt Lake City, UT, where luxury meets convenience! Explore our diverse floor plans, including studios, one-bedroom, and two-bedroom options. Enjoy premium amenities like a yoga studio, coffee bar, pet play area, and bocce ball court, with furnished units available for your comfort. Our bilingual leasing team is ready to assist you. Have questions? Browse our FAQs page for answers about our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Salt Lake City, UT",
  "property_seo_description_reviews": "Discover why residents love The Ritz Classic in Salt Lake City, UT! Explore our diverse floor plans including studios, one-bedroom, and two-bedroom apartments. Enjoy amazing amenities like a yoga studio, pet play area, coffee bar, and bocce ball. Plus, take advantage of our bilingual leasing team and thoughtfully furnished units. Curious about the community? See what our residents have to say about living at The Ritz Classic!",
  "property_seo_title_applynow": "Apply Now | Apartments in Salt Lake City, UT",
  "property_seo_description_applynow": "Discover your ideal living space at The Ritz Classic in Salt Lake City, UT! Choose from stylish floor plans, including studios, one, and two-bedroom apartments. Enjoy top-notch amenities such as a yoga studio, pet-friendly dog park, and a cozy coffee bar. Our bilingual leasing team is here to assist you, and furnished units are available to fit your lifestyle. With granite countertops, bocce ball, and electric car charging stations, take the next step towards your new home. Apply online today and embrace vibrant community living!",
  "property_seo_title_residentaccess": "Resident Access | The Ritz Classic",
  "property_seo_description_residentaccess": "\"Log in to The Ritz Classic resident portal in Salt Lake City, UT, for seamless rent payments, maintenance requests, and community updates. Access your exclusive tools today!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Ritz Classic",
  "property_seo_description_referafriend": "\"Refer a friend to The Ritz Classic in Salt Lake City, UT! Enjoy the charm of our vibrant community where great friends make great neighbors. Share the joy of living here and discover exclusive rewards. Start referring today!\"",
  "property_seo_title_scheduletour": "Schedule Tour | The Ritz Classic in Salt Lake City, UT",
  "property_seo_description_scheduletour": "Experience the best of apartment living at The Ritz Classic in Salt Lake City, UT. Schedule a tour today to view our modern apartments!",
  "property_seo_title_privacy": "Privacy Policy | The Ritz Classic",
  "property_seo_description_privacy": "The Ritz Classic prioritizes your privacy. Our comprehensive privacy policy outlines our commitment to safeguarding your personal information.",
  "property_seo_title_accessibility": "Accessibility | The Ritz Classic",
  "property_seo_description_accessibility": "Discover inclusive living at The Ritz Classic in Salt Lake City, UT. Our Accessibility Statement ensures all residents enjoy a seamless experience.",
  "property_seo_title_sitemap": "Sitemap | The Ritz Classic",
  "property_seo_description_sitemap": "Explore The Ritz Classic in Salt Lake City, UT! Navigate our sitemap for a comprehensive view of our luxury apartment community layouts.",
  "property_seo_title_thankyou": "Thank You | The Ritz Classic",
  "property_seo_description_thankyou": "Thank you for your interest in The Ritz Classic in Salt Lake City, UT! Your submission has been received, and our dedicated team will reach out to you shortly.",
  "property_seo_title_pets": "Pet Policy | The Ritz Classic in Salt Lake City, UT",
  "property_seo_description_pets": "Learn more about the pet policy at The Ritz Classic in Salt Lake City, UT and view our pet amenities. Pet play area, treats in office, and more!",
  "property_updated_at": "1791293567093",
  "amenities": [
    {
      "id": "ec_4093f125cfaa11d8148dd111",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "87365661",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d99d9-2287-70df-82ee-43490205b7f2.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at apartment complex.",
        "public_id": "019d99d9-2287-70df-82ee-43490205b7f2",
        "storage_key": "property/6286356741357568/019d99d9-2287-70df-82ee-43490205b7f2.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Ritz Classic Outdoor Pool, Weidner Real Estate Properties",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3a51e7ed9e52c98acd95112",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211365",
      "title": "Fitness Center with Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d99d9-1906-77aa-aa78-b48036b1b257.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, stationary bikes, and elliptical machines.",
        "public_id": "019d99d9-1906-77aa-aa78-b48036b1b257",
        "storage_key": "property/6286356741357568/019d99d9-1906-77aa-aa78-b48036b1b257.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Ritz Classic Fitness Center with Cardio Machines, Weidner Real Estate Properties",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1c9e98be1d947ef0ff0a6d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211360",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d99d9-1a54-775d-8ac7-d2c59194147a.webp",
      "amenity_image_media": {
        "alt_text": "Modern community lounge area with seating, a bar, and televisions.",
        "public_id": "019d99d9-1a54-775d-8ac7-d2c59194147a",
        "storage_key": "property/6286356741357568/019d99d9-1a54-775d-8ac7-d2c59194147a.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Ritz Classic Clubhouse and Kitchen, Weidner Real Estate Properties",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7158aecdc95bc86060a9f1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211359",
      "title": "Parking Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d99d9-16a8-7728-99ae-bb3e51e31ec2.webp",
      "amenity_image_media": {
        "alt_text": "Spacious underground parking garage with white pillars and painted lines for parking spots.",
        "public_id": "019d99d9-16a8-7728-99ae-bb3e51e31ec2",
        "storage_key": "property/6286356741357568/019d99d9-16a8-7728-99ae-bb3e51e31ec2.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Ritz Classic Covered Garage Parking, Dean Weidner Real Estate",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e96cd7e8a36a8fd5fc6dbab9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211301",
      "title": "Historic Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d99d9-179a-71a6-877d-a7ecc42dd0e2.webp",
      "amenity_image_media": {
        "alt_text": "Classic Apartment Homes monument sign with address 2265 State St.",
        "public_id": "019d99d9-179a-71a6-877d-a7ecc42dd0e2",
        "storage_key": "property/6286356741357568/019d99d9-179a-71a6-877d-a7ecc42dd0e2.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Ritz Classic Bowling Pin Sign",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d67301f428a853178fde83d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86228163",
      "title": "Fire Pits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4125d7146c17a273dc94774",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211363",
      "title": "BBQ/Grilling Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fcc346512cc52a3eccf52d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211362",
      "title": "Bike Racks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97d790a6a01c792a8629c2b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211358",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48ecbe5f8d8f13703d7589a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211305",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_690eb14c68b6fa9dbaed9e53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211303",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be85b6cd5ac0fca9bc307884",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211302",
      "title": "Night Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7735ff0e1294c78234ef7a1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211300",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3dc7a3ed3a6c47ed4cb145cc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211370",
      "title": "Energy Efficient Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Ritz Classic 2 Bedroom Kitchen and Living Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bf6294a19282f01482df84c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211379",
      "title": "Full-Size Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d99d9-377d-7664-8774-5f3aff0abb3a.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer in laundry room",
        "public_id": "019d99d9-377d-7664-8774-5f3aff0abb3a",
        "storage_key": "property/6286356741357568/019d99d9-377d-7664-8774-5f3aff0abb3a.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Ritz Classic 2 Bedroom With Full-Size Washer and Dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a900adc51a3ff91560d7b40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211368",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d99d9-39eb-75fe-8714-36bb8e28e796.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen island with sink and dishwasher, leading to living area and balcony with mountain view.",
        "public_id": "019d99d9-39eb-75fe-8714-36bb8e28e796",
        "storage_key": "property/6286356741357568/019d99d9-39eb-75fe-8714-36bb8e28e796.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Ritz Classic 1 Bedroom Kitchen With Stainless Steel Appliances",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cde24912ab23a94f4f680ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211378",
      "title": "Mountain and City Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2a4ffcb1598ffd011fede7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211380",
      "title": "Walk-in Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f327d80c0bfb2ef2ebbae2f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211377",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f8516c8df678ba36ba49e46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211375",
      "title": "Hardwood Floors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1acc67bb2711405a6c15731",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211373",
      "title": "Central Air Conditioning and Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00e523514df13d21727da257",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211369",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc27aab6e286b85cdeb829e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211376",
      "title": "Patio/Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f778992e4b4f45a2b5707262",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211366",
      "title": "Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a3-d9f6-7567-b34e-a5fa03e37b6a.webp",
      "amenity_image_media": {
        "alt_text": "Fitness room with exercise balls, weights, and a TV.",
        "public_id": "019d01a3-d9f6-7567-b34e-a5fa03e37b6a",
        "storage_key": "property/6286356741357568/019d01a3-d9f6-7567-b34e-a5fa03e37b6a.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Ritz Classic Yoga and Stretching Room, Weidner Real Estate Properties",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d87460cb5c37286fc41658f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211371",
      "title": "Pantry*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c7c9314daf8294bc15bb71c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211372",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f0037c1fa4335ac12694914",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "126782172",
      "title": "12 ft Ceiling",
      "amount": "false",
      "description": "12 ft Ceiling",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c6f10611ec89393d31b6e2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "126782173",
      "title": "12ft Ceiling",
      "amount": "false",
      "description": "12ft Ceiling",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ad6a29118e817e5f24b1bd9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "126782175",
      "title": "16 ft Ceiling",
      "amount": "false",
      "description": "16 ft Ceiling",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1920636c4195fb20b350819",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "126782176",
      "title": "18ft Ceiling",
      "amount": "false",
      "description": "18ft Ceiling",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_836427df30ccd2e73178e6e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211306",
      "title": "Bilingual Leasing Team Members",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bc0b1af711573c768a71956",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "126782178",
      "title": "Accessible",
      "amount": "false",
      "description": "Accessible",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea0c36d9d9b8fed7acc6265b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211311",
      "title": "Furnished Units Available*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fed63f37d9f5574989bde90f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "126782179",
      "title": "Corner Unit",
      "amount": "false",
      "description": "Corner Unit",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9eeb1608ea03fee9ad85421",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211361",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c41d45b8c09fab34a5100ea8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "126782180",
      "title": "Floor Level 2",
      "amount": "false",
      "description": "Floor Level 2",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c4b1764fdf386199df42e4d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211364",
      "title": "Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e6e67ec776fe09eb72fd917",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "126782181",
      "title": "Floor Level 3",
      "amount": "false",
      "description": "Floor Level 3",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76d3fe103a25519f9707988e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "86211367",
      "title": "Bocce Ball",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d59fd9c6e15d0a85049df8a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "88009505",
      "title": "Electric Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ca9f17f95d5d5cbf72a01227",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13282-d29c-713d-b2d6-e865e7f9a316.webp",
      "image_media": {
        "alt_text": "Lobby area with a modern fireplace and abstract art",
        "public_id": "01a13282-d29c-713d-b2d6-e865e7f9a316",
        "storage_key": "property/6286356741357568/01a13282-d29c-713d-b2d6-e865e7f9a316.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby, featuring a cozy fireplace and sophisticated modern art. A perfect space to gather or find a quiet moment.",
      "link": "false",
      "alt_text": "A living room with a fireplace and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(39).jpg"
    },
    {
      "id": "ec_4d4376619f2e74aa5d139839",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13282-c560-77a8-ae6a-36103296a094.webp",
      "image_media": {
        "alt_text": "Lobby area with seating, abstract art, and entrance doors.",
        "public_id": "01a13282-c560-77a8-ae6a-36103296a094",
        "storage_key": "property/6286356741357568/01a13282-c560-77a8-ae6a-36103296a094.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our sophisticated lobby, featuring comfortable seating and modern art. The grand entrance welcomes you home.",
      "link": "false",
      "alt_text": "A modern living room with a grey sofa and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(35).jpg"
    },
    {
      "id": "ec_27b1e2109a474df6ade7c963",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13289-d411-7107-9d83-bcc952d29eb4.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with island seating.",
        "public_id": "01a13289-d411-7107-9d83-bcc952d29eb4",
        "storage_key": "property/6286356741357568/01a13289-d411-7107-9d83-bcc952d29eb4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a comfortable sofa, elegant armchairs, and a modern kitchen with ample cabinet space and island seating.",
      "link": "false",
      "alt_text": "A living room with a couch, coffee table, and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(34).jpg"
    },
    {
      "id": "ec_597e3f2d1214ca031c2e9dce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13282-d49c-755f-8f35-ea51dc86c58f.webp",
      "image_media": {
        "alt_text": "Living room with modern furnishings and large window overlooking a cityscape.",
        "public_id": "01a13282-d49c-755f-8f35-ea51dc86c58f",
        "storage_key": "property/6286356741357568/01a13282-d49c-755f-8f35-ea51dc86c58f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience sophisticated urban living in this stylish apartment, featuring a spacious living area with contemporary decor and stunning city views.",
      "link": "false",
      "alt_text": "A living room with a brown floor and furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(33).jpg"
    },
    {
      "id": "ec_a6ab563b2a810138da137ae0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13282-d1d0-74ad-96bd-977221fe020f.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a large window and blue bedding.",
        "public_id": "01a13282-d1d0-74ad-96bd-977221fe020f",
        "storage_key": "property/6286356741357568/01a13282-d1d0-74ad-96bd-977221fe020f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant nightstands, and ample natural light from a large window.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and two lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(32).jpg"
    },
    {
      "id": "ec_c412a321c9a902c3ff1cd326",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-1e25-739a-ab3d-56732c07a9a6.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, ellipticals, and stationary bikes, overlooking apartments.",
        "public_id": "01a13283-1e25-739a-ab3d-56732c07a9a6",
        "storage_key": "property/6286356741357568/01a13283-1e25-739a-ab3d-56732c07a9a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, free weights, and plenty of space to move.",
      "link": "false",
      "alt_text": "A spacious gym with a variety of equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(31).jpg"
    },
    {
      "id": "ec_9ca5348c1d115e1eb2805895",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-2892-75ca-b200-11830a5316c6.webp",
      "image_media": {
        "alt_text": "Fitness room with TRX straps and mirrored walls",
        "public_id": "01a13283-2892-75ca-b200-11830a5316c6",
        "storage_key": "property/6286356741357568/01a13283-2892-75ca-b200-11830a5316c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with TRX suspension trainers and a large mirror.",
      "link": "false",
      "alt_text": "A gym with a television mounted on the wall and a row of TRX straps hanging from a rack.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(30).jpg"
    },
    {
      "id": "ec_f73ed16dfff4829abed97d3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13289-a723-743d-aa6a-b5b217ebc13b.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room with stainless steel appliances and stylish furniture.",
        "public_id": "01a13289-a723-743d-aa6a-b5b217ebc13b",
        "storage_key": "property/6286356741357568/01a13289-a723-743d-aa6a-b5b217ebc13b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with stainless steel appliances and a comfortable living room.",
      "link": "false",
      "alt_text": "A modern kitchen with white cabinets and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(29).jpg"
    },
    {
      "id": "ec_00482242c7a4104d11c7c392",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-5268-711a-8f42-3210ba6d3317.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, granite countertops, stainless steel appliances, and island seating.",
        "public_id": "01a13283-5268-711a-8f42-3210ba6d3317",
        "storage_key": "property/6286356741357568/01a13283-5268-711a-8f42-3210ba6d3317.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring elegant wood cabinetry, granite countertops, a large island with seating, and stainless steel appliances for a luxurious cooking experience.",
      "link": "false",
      "alt_text": "A kitchen with a wooden island and stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(28).jpg"
    },
    {
      "id": "ec_8e75baea683a7d260fd17d10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-663d-762b-b218-22a8a984eeac.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and wood cabinets.",
        "public_id": "01a13283-663d-762b-b218-22a8a984eeac",
        "storage_key": "property/6286356741357568/01a13283-663d-762b-b218-22a8a984eeac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring granite countertops, stainless steel appliances, and ample cabinet space for all your storage needs.",
      "link": "false",
      "alt_text": "A modern kitchen with a granite countertop and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(27).jpg"
    },
    {
      "id": "ec_2752b2fbef9bdcd4fa501ac6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-5d2f-732a-947f-7e868f6bc020.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet.",
        "public_id": "01a13283-5d2f-732a-947f-7e868f6bc020",
        "storage_key": "property/6286356741357568/01a13283-5d2f-732a-947f-7e868f6bc020.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry days.",
      "link": "false",
      "alt_text": "A white door opens to a small laundry room with a washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(26).jpg"
    },
    {
      "id": "ec_0bac45bc5a6aa52b9587a248",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-8af6-7109-85a5-2346c5f07ceb.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertops and a large mirror, with a glimpse of the bedroom.",
        "public_id": "01a13283-8af6-7109-85a5-2346c5f07ceb",
        "storage_key": "property/6286356741357568/01a13283-8af6-7109-85a5-2346c5f07ceb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a modern vanity, granite countertops, and a full-length mirror. Step into the inviting bedroom through the open doorway.",
      "link": "false",
      "alt_text": "A bathroom with a white vanity and a mirror above it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(25).jpg"
    },
    {
      "id": "ec_e85fa14ca11e49b5e9c43862",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-9dc9-759f-ad12-58d69f85fdb4.webp",
      "image_media": {
        "alt_text": "Living room with sofa, chairs, coffee table, and balcony view.",
        "public_id": "01a13283-9dc9-759f-ad12-58d69f85fdb4",
        "storage_key": "property/6286356741357568/01a13283-9dc9-759f-ad12-58d69f85fdb4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating, elegant decor, and a large window offering a scenic view.",
      "link": "false",
      "alt_text": "A living room with a couch, chair, and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(23).jpg"
    },
    {
      "id": "ec_07e0f501536db208923827a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13289-d54e-724d-a4ae-af93e9dddfb2.webp",
      "image_media": {
        "alt_text": "Cozy living area with a large window, plush sofa, and decorative pillows.",
        "public_id": "01a13289-d54e-724d-a4ae-af93e9dddfb2",
        "storage_key": "property/6286356741357568/01a13289-d54e-724d-a4ae-af93e9dddfb2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting living space, featuring a comfortable sofa, stylish decor, and abundant natural light from a large window.",
      "link": "false",
      "alt_text": "A living room with a grey couch, a white chair, and a framed picture on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(22).jpg"
    },
    {
      "id": "ec_531af26cff0a0780138d8970",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-9779-7441-ba73-7d769147ff33.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a fireplace and comfortable seating.",
        "public_id": "01a13283-9779-7441-ba73-7d769147ff33",
        "storage_key": "property/6286356741357568/01a13283-9779-7441-ba73-7d769147ff33.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in the stylish lounge area featuring a contemporary fireplace and plush seating, perfect for socializing or unwinding.",
      "link": "false",
      "alt_text": "A living room with a fireplace and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(21).jpg"
    },
    {
      "id": "ec_3f9006959b11f48ed7252e67",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-c44e-77fa-9cee-e83fce63509a.webp",
      "image_media": {
        "alt_text": "Treadmills and weight equipment in a modern apartment complex gym.",
        "public_id": "01a13283-c44e-77fa-9cee-e83fce63509a",
        "storage_key": "property/6286356741357568/01a13283-c44e-77fa-9cee-e83fce63509a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, free weights, and a dedicated stretching area. It's the perfect place to start or end your day.",
      "link": "false",
      "alt_text": "A spacious gym with a variety of equipment including treadmills, stationary bikes, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(20).jpg"
    },
    {
      "id": "ec_ba865ad552b62f3662f33e50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13284-7174-75af-bab5-6763fa4ff60a.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with red umbrellas and modern furniture on a sunny day.",
        "public_id": "01a13284-7174-75af-bab5-6763fa4ff60a",
        "storage_key": "property/6286356741357568/01a13284-7174-75af-bab5-6763fa4ff60a.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor seating area, complete with comfortable furniture and vibrant red umbrellas, perfect for enjoying the fresh air and scenic views.",
      "link": "false",
      "alt_text": "A red umbrella is on a patio table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(24).jpg"
    },
    {
      "id": "ec_25b79b1fbf497c33936262ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-d98b-709b-b5e2-0afed49f258d.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a wet bar, bar stools, and seating.",
        "public_id": "01a13283-d98b-709b-b5e2-0afed49f258d",
        "storage_key": "property/6286356741357568/01a13283-d98b-709b-b5e2-0afed49f258d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge, featuring a sleek wet bar with bar stools and comfortable seating areas perfect for gathering.",
      "link": "false",
      "alt_text": "A modern living room with a bar area and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(19).jpg"
    },
    {
      "id": "ec_1b7da5bc34b75e343b3d9717",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-d9ed-74cd-8d1c-10d7c58a408c.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with tables, chairs, umbrellas, and a grill, overlooking a courtyard with green space.",
        "public_id": "01a13283-d9ed-74cd-8d1c-10d7c58a408c",
        "storage_key": "property/6286356741357568/01a13283-d9ed-74cd-8d1c-10d7c58a408c.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling on the patio, complete with comfortable seating and vibrant umbrellas. A perfect space for gatherings and relaxation.",
      "link": "false",
      "alt_text": "A patio with tables and chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(41).jpg"
    },
    {
      "id": "ec_08ddd24fcdd301c3c66dd191",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13283-f683-7029-a45b-c24138ae7613.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and dining area with grills, tables, and umbrellas.",
        "public_id": "01a13283-f683-7029-a45b-c24138ae7613",
        "storage_key": "property/6286356741357568/01a13283-f683-7029-a45b-c24138ae7613.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining in our beautifully appointed outdoor kitchen and lounge area. Perfect for entertaining guests or relaxing al fresco.",
      "link": "false",
      "alt_text": "A patio with tables and chairs under a striped umbrella.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(36).jpg"
    },
    {
      "id": "ec_2de6a3df34a0be050c0db2e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13284-0ac8-70fe-b294-4c479fc9ad6c.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a13284-0ac8-70fe-b294-4c479fc9ad6c",
        "storage_key": "property/6286356741357568/01a13284-0ac8-70fe-b294-4c479fc9ad6c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and vibrant red umbrellas. Perfect for a relaxing day under the sun.",
      "link": "false",
      "alt_text": "A pool area with red umbrellas and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(37).jpg"
    },
    {
      "id": "ec_a41cbe4a887a6c6f2439d0fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13289-a3b4-733a-a93c-866c52376fee.webp",
      "image_media": {
        "alt_text": "Courtyard with bocce ball court and outdoor seating areas",
        "public_id": "01a13289-a3b4-733a-a93c-866c52376fee",
        "storage_key": "property/6286356741357568/01a13289-a3b4-733a-a93c-866c52376fee.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on the bocce ball court or relax in the courtyard seating areas, perfect for socializing.",
      "link": "false",
      "alt_text": "A blue ball is on a green lawn in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(38).jpg"
    },
    {
      "id": "ec_ac4bf1983223940e65832c28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13284-12dd-72ac-a5f9-487ec5d4c865.webp",
      "image_media": {
        "alt_text": "Outdoor bocce ball court and seating area with apartment buildings in the background.",
        "public_id": "01a13284-12dd-72ac-a5f9-487ec5d4c865",
        "storage_key": "property/6286356741357568/01a13284-12dd-72ac-a5f9-487ec5d4c865.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Enjoy outdoor games and relaxation in the community bocce ball court, complete with comfortable seating and cabana.",
      "link": "false",
      "alt_text": "A playground area with a red track, yellow chairs and a brown umbrella.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(42).jpg"
    },
    {
      "id": "ec_dfc821c338c75d4d60ac1b7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13284-6887-71dc-95ed-de1b2e32fabb.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a13284-6887-71dc-95ed-de1b2e32fabb",
        "storage_key": "property/6286356741357568/01a13284-6887-71dc-95ed-de1b2e32fabb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and the modern architecture of our community.",
      "link": "false",
      "alt_text": "A pool with a red umbrella and yellow chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(40).jpg"
    },
    {
      "id": "ec_21f5da0d6e18693dcf76ce5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/01a13284-2748-7359-a4b8-7ce75903325c.webp",
      "image_media": {
        "alt_text": "Exterior of a modern brick apartment building with balconies and large windows.",
        "public_id": "01a13284-2748-7359-a4b8-7ce75903325c",
        "storage_key": "property/6286356741357568/01a13284-2748-7359-a4b8-7ce75903325c.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "A contemporary brick apartment building featuring multiple balconies and expansive windows, offering a sleek and modern living space.",
      "link": "false",
      "alt_text": "A red brick building with balconies and windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Ritz_Classic_Favorites%20(43).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b1ef1652-1d9e-49bc-a565-65ebd3ad1064",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "3715 Constitution Blvd, West Valley City, UT 84119, USA",
      "poi_short_description": "Fast food chain known for its classic burgers, fries, and shakes, plus a drive-thru.",
      "poi_long_description": "People say this hamburger restaurant serves delicious animal fries, burgers, and shakes. They highlight the affordable prices and fast service. They also like the friendly staff and clean dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-426e-710a-b91c-355c74f11b18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-426e-710a-b91c-355c74f11b18",
        "storage_key": "property/6286356741357568/019d01a4-426e-710a-b91c-355c74f11b18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/245",
      "poi_directions_map_url": "https://maps.google.com/?cid=17164510857675952614&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "40.6914496",
      "poi_longitude": "-111.9576055",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-946f-741c-968a-d44d88cb458f",
        "storage_key": "property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUt1UYOMUocR5lEc_66XNO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_504769ff-203a-4fff-92cb-70b4165747b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Raising Cane’s Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2150 S State St, South Salt Lake, UT 84115, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves great chicken fingers, Texas toast, and Cane's sauce. They also highlight the quick service, friendly staff, and clean environment.\n\nOther reviews mention the chicken fingers can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-4211-754b-a936-2578ca5a2845.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-4211-754b-a936-2578ca5a2845",
        "storage_key": "property/6286356741357568/019d01a4-4211-754b-a936-2578ca5a2845.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ut/south-salt-lake/2150-s-state-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=18425726988590759800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "40.7240071",
      "poi_longitude": "-111.8888015",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-988-0019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-946f-741c-968a-d44d88cb458f",
        "storage_key": "property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVAfT0yLUocReL9HixJVtf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_2aa34093-525b-4716-8ba4-8bcddeea101f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Red Iguana",
      "poi_type": "Restaurants",
      "poi_address": "736 W North Temple St, Salt Lake City, UT 84116, USA",
      "poi_short_description": "Enchiladas, fajitas, and more offered in a cozy space beloved for traditional Mexican food.",
      "poi_long_description": "People say this Mexican restaurant serves delicious and authentic mole dishes, tacos, and enchiladas. They highlight the generous portions, reasonable prices, and lively atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-42d7-71cf-96a7-62e7b337645f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-42d7-71cf-96a7-62e7b337645f",
        "storage_key": "property/6286356741357568/019d01a4-42d7-71cf-96a7-62e7b337645f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rediguana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11516129657914646960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "red-iguana",
      "poi_latitude": "40.7718053",
      "poi_longitude": "-111.9124897",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-322-1489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-946f-741c-968a-d44d88cb458f",
        "storage_key": "property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm_zJw1b0UocRsOFXp-iC0Z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_021a75d6-e076-42c1-82b6-b0d28cd648bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Slackwater Pizza SLC",
      "poi_type": "Restaurants",
      "poi_address": "684 S 500 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Casual pizza restaurant serving artisan pies with vegan options, plus beer, wine, and cocktails.",
      "poi_long_description": "People say this restaurant serves delicious and unique pizzas, calzones, and wings, with a wide selection of craft beers. They highlight the reasonable prices and lively, fun atmosphere. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-43ca-74be-88c9-9be1c3996f37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-43ca-74be-88c9-9be1c3996f37",
        "storage_key": "property/6286356741357568/019d01a4-43ca-74be-88c9-9be1c3996f37.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.slackwaterpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14951801590224390378&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "slackwater-pizza-slc",
      "poi_latitude": "40.75444299999999",
      "poi_longitude": "-111.9056934",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-386-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-946f-741c-968a-d44d88cb458f",
        "storage_key": "property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1ccyxz1UocR6ghyCVR4f88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f106b4c4-37ee-4366-bc0a-50915366340e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Red Iguana 2",
      "poi_type": "Restaurants",
      "poi_address": "866 W S Temple St, Salt Lake City, UT 84104, USA",
      "poi_short_description": "Casual Mexican restaurant for enchiladas, fajitas, and other favorites, plus cocktails.",
      "poi_long_description": "People say this Mexican restaurant serves delicious mole, chimichangas, and fish tacos. They highlight the authentic flavors, generous portions, and the option to sample different moles. They also like the quick service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-4811-7002-b9a7-a7d9260d60e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-4811-7002-b9a7-a7d9260d60e8",
        "storage_key": "property/6286356741357568/019d01a4-4811-7002-b9a7-a7d9260d60e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rediguana.com/locations/red-iguana-2/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8438835085975497207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "red-iguana-2",
      "poi_latitude": "40.769692",
      "poi_longitude": "-111.9161652",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-214-6050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-946f-741c-968a-d44d88cb458f",
        "storage_key": "property/6286356741357568/019d01a4-946f-741c-968a-d44d88cb458f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj096gVf0UocR9ymswczDHHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7e5d4850-444c-4e93-bf3e-fb0314b4035c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Fashion Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "6191 S State St, Murray, UT 84107, USA",
      "poi_short_description": "Mall with a food court and many shopping options, including clothing stores, plus a restroom.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including Nordstrom and The Cheesecake Factory, and a diverse food court. They also highlight the clean and well-maintained environment, and the convenient parking.\n\nOther reviews mention it can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-4973-7639-88d0-252f00f2d4fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-4973-7639-88d0-252f00f2d4fa",
        "storage_key": "property/6286356741357568/019d01a4-4973-7639-88d0-252f00f2d4fa.webp",
        "width": 1280,
        "height": 510
      },
      "poi_business_url": "https://www.fashionplace.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11422916794548893256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "fashion-place",
      "poi_latitude": "40.6372542",
      "poi_longitude": "-111.8868617",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-262-9448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9460-77ba-b948-6bd9f0aa61e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9460-77ba-b948-6bd9f0aa61e0",
        "storage_key": "property/6286356741357568/019d01a4-9460-77ba-b948-6bd9f0aa61e0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa8t_-L6JUocRSDburU1ahp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9ee34b3a-365a-4be4-9306-c6a413507086",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "City Creek Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "50 S Main St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Upscale shopping center with over 100 stores, a landscaped stream, and seasonal events.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and a food court, with both indoor and outdoor spaces. They highlight the beautiful landscaping, water features, and the creek that flows through the center, creating a fun and family-friendly atmosphere. They also like the convenient underground parking and the easy-to-navigate layout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-4966-72e8-94e3-5435f83cb64d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-4966-72e8-94e3-5435f83cb64d",
        "storage_key": "property/6286356741357568/019d01a4-4966-72e8-94e3-5435f83cb64d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopcitycreekcenter.com/?utm_source=GoogleMyBusiness&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=1429749320349744761&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "city-creek-center",
      "poi_latitude": "40.76833329999999",
      "poi_longitude": "-111.8913889",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-521-2012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9460-77ba-b948-6bd9f0aa61e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9460-77ba-b948-6bd9f0aa61e0",
        "storage_key": "property/6286356741357568/019d01a4-9460-77ba-b948-6bd9f0aa61e0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqVbctwj1UocReX5NhW591xM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b855db75-1161-4860-9150-f6b613541eb1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Chinatown Supermarket - 中國城超市",
      "poi_type": "Shopping & Retail",
      "poi_address": "3390 State St #11, South Salt Lake, UT 84115, USA",
      "poi_short_description": "Grocery store with a wide selection of ingredients from Korea, Japan, China, and other Asian countries.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh produce, meats, seafood, snacks, and pantry staples, as well as a bakery with delicious pastries and boba. They highlight the reasonable prices and fun, lively atmosphere with claw machines and nearby restaurants. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-4aa0-7525-8291-0a20808219f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-4aa0-7525-8291-0a20808219f8",
        "storage_key": "property/6286356741357568/019d01a4-4aa0-7525-8291-0a20808219f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chinatown-supermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1977936213840259000&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "chinatown-supermarket---",
      "poi_latitude": "40.6979988",
      "poi_longitude": "-111.8898417",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-906-8788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9493-7355-acf9-ccd7922c5418.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9493-7355-acf9-ccd7922c5418",
        "storage_key": "property/6286356741357568/019d01a4-9493-7355-acf9-ccd7922c5418.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3fgyB_eKUocRuGdUxoEKcxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_cdb95327-e200-4449-bf8c-325416d957f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "634 E 400 S, Salt Lake City, UT 84102, USA",
      "poi_short_description": "Neighborhood grocery store featuring conventional items alongside unique offerings and quality produce.",
      "poi_long_description": "People say this grocery store offers a wide variety of unique items, healthy food, and snacks. They highlight the reasonable prices and fun, exciting shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-4e48-755b-a611-f8c67302f214.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-4e48-755b-a611-f8c67302f214",
        "storage_key": "property/6286356741357568/019d01a4-4e48-755b-a611-f8c67302f214.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://locations.traderjoes.com/ut/salt-lake-city/350/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1822967084851718382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "40.7596942",
      "poi_longitude": "-111.8725988",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-359-2462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9493-7355-acf9-ccd7922c5418.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9493-7355-acf9-ccd7922c5418",
        "storage_key": "property/6286356741357568/019d01a4-9493-7355-acf9-ccd7922c5418.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIymmPmn1UocR7ujQued6TBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7f8df70e-a48c-432d-b72b-5dc2bf21d361",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Valley Fair Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3601 S 2700 W, West Valley City, UT 84119, USA",
      "poi_short_description": "Large mall featuring over 120 stores, plus dining options, a movie theater, and a splash pad.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including Bath & Body Works, and a food court. They also highlight the convenient location with nearby restaurants and stores.\n\nOther reviews mention the mall can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-5011-716d-b4e4-c7b6b3f4dad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-5011-716d-b4e4-c7b6b3f4dad3",
        "storage_key": "property/6286356741357568/019d01a4-5011-716d-b4e4-c7b6b3f4dad3.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://shopvalleyfair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10434666986797163243&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "valley-fair-mall",
      "poi_latitude": "40.6936048",
      "poi_longitude": "-111.9537424",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-969-6211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9460-77ba-b948-6bd9f0aa61e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9460-77ba-b948-6bd9f0aa61e0",
        "storage_key": "property/6286356741357568/019d01a4-9460-77ba-b948-6bd9f0aa61e0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIRNkHZ2MUocR62KK2VZiz5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_80555471-c90b-45ed-a269-d65e466b2128",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "The University of Utah",
      "poi_type": "Education",
      "poi_address": "201 Presidents' Cir, Salt Lake City, UT 84112, USA",
      "poi_short_description": "This research university near the Wasatch Mountains features 100 acres of gardens plus an arboretum.",
      "poi_long_description": "This research university near the Wasatch Mountains features 100 acres of gardens plus an arboretum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-4f5e-736f-8204-af6250c77373.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-4f5e-736f-8204-af6250c77373",
        "storage_key": "property/6286356741357568/019d01a4-4f5e-736f-8204-af6250c77373.webp",
        "width": 715,
        "height": 477
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15966664552946993518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "the-university-of-utah",
      "poi_latitude": "40.7649368",
      "poi_longitude": "-111.8421021",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 801-581-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-945b-77fa-9a85-1f7e7f190c09",
        "storage_key": "property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG_NN6OpfUocRbgk63tD8lN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e5405241-7109-4050-aaca-cb0e76ab5d96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Salt Lake Community College Taylorsville Redwood Campus",
      "poi_type": "Education",
      "poi_address": "4600 S Redwood Rd, Salt Lake City, UT 84123, USA",
      "poi_short_description": "Campus hub for textbooks, school supplies & electronics, plus some grab-&-go snacks.",
      "poi_long_description": "Campus hub for textbooks, school supplies & electronics, plus some grab-&-go snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-5403-7349-9822-93a8b5aabe63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-5403-7349-9822-93a8b5aabe63",
        "storage_key": "property/6286356741357568/019d01a4-5403-7349-9822-93a8b5aabe63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.slcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14376552573467281300&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "salt-lake-community-college-taylorsville-redwood-campus",
      "poi_latitude": "40.672139",
      "poi_longitude": "-111.9427925",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-957-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-945b-77fa-9a85-1f7e7f190c09",
        "storage_key": "property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOSM-CI6LUocRlMc-NGXGg8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dbadd460-a3cb-4539-9ca5-8f977d832731",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Salt Lake City Public Library",
      "poi_type": "Education",
      "poi_address": "210 E 400 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Modern library known for its natural light & curved 6-story walkable wall built with high-UV glass.",
      "poi_long_description": "People say this public library offers a wide variety of books, computers, and facilities, including a rooftop garden and a children's area. They highlight the beautiful architecture, the clean and well-maintained environment, and the comfortable seating areas. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-53e9-758b-bfc3-5b19a964ecaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-53e9-758b-bfc3-5b19a964ecaf",
        "storage_key": "property/6286356741357568/019d01a4-53e9-758b-bfc3-5b19a964ecaf.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://services.slcpl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=66428271525700298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "salt-lake-city-public-library",
      "poi_latitude": "40.7600376",
      "poi_longitude": "-111.8846127",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-524-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-945b-77fa-9a85-1f7e7f190c09",
        "storage_key": "property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr0salBP1UocRyiJVNykA7AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_2241f4fc-e0a7-432a-9061-a7dde7e04848",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Ensign College",
      "poi_type": "Education",
      "poi_address": "95 N 300 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-556f-769a-a967-6d217755818e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-556f-769a-a967-6d217755818e",
        "storage_key": "property/6286356741357568/019d01a4-556f-769a-a967-6d217755818e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.ensign.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13914062519158002785&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "ensign-college",
      "poi_latitude": "40.7711865",
      "poi_longitude": "-111.9002464",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-524-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-945b-77fa-9a85-1f7e7f190c09",
        "storage_key": "property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ45sdcqr1UocRYVT9LCSuGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0dd05c23-b4f7-462d-90b2-113ec85db0da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Western Governors University",
      "poi_type": "Education",
      "poi_address": "4001 S 700 E #300, Millcreek, UT 84107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-581f-71eb-a244-28eda3a3f0c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-581f-71eb-a244-28eda3a3f0c2",
        "storage_key": "property/6286356741357568/019d01a4-581f-71eb-a244-28eda3a3f0c2.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.wgu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7171981244280544930&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "western-governors-university",
      "poi_latitude": "40.6847421",
      "poi_longitude": "-111.8698951",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-274-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-945b-77fa-9a85-1f7e7f190c09",
        "storage_key": "property/6286356741357568/019d01a4-945b-77fa-9a85-1f7e7f190c09.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBVZvCm6KUocRoh4bYfH-h2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a3594c6a-cd24-47fb-9933-3f913155734d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Delta Center",
      "poi_type": "Entertainment",
      "poi_address": "301 S Temple, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Sporting events and concerts take place at this venue offering a variety of dining options.",
      "poi_long_description": "People say this arena offers a variety of events, including concerts, hockey games, and basketball games. They highlight the clean facilities, convenient access, and helpful staff. They also like the organized events and smooth entry and exit process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-5a96-77ed-aa07-014a0d1f1c2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-5a96-77ed-aa07-014a0d1f1c2d",
        "storage_key": "property/6286356741357568/019d01a4-5a96-77ed-aa07-014a0d1f1c2d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.deltacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17358356562075300128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "delta-center",
      "poi_latitude": "40.7682681",
      "poi_longitude": "-111.9010874",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-325-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfDrAwH1UocRILERH1NF5fA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_7bc5084f-aa7f-4cb7-ba11-5d947bed9d0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Temple Square",
      "poi_type": "Entertainment",
      "poi_address": "50 North Temple, Salt Lake City, UT 84150, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this historical landmark offers beautiful architecture, stunning views, and a peaceful atmosphere. They highlight the gorgeous flowers, the organ recital, and the helpful missionaries. They also like the clean grounds and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-5a74-76db-93fb-0fa6f2ee75ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-5a74-76db-93fb-0fa6f2ee75ed",
        "storage_key": "property/6286356741357568/019d01a4-5a74-76db-93fb-0fa6f2ee75ed.webp",
        "width": 612,
        "height": 612
      },
      "poi_business_url": "https://www.churchofjesuschrist.org/feature/templesquare?lang=eng&y_source=1_MzA1ODU2NjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10112787064908179005&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "temple-square",
      "poi_latitude": "40.7704323",
      "poi_longitude": "-111.8925384",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-240-8945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Q6J5Aj1UocRPWYEdUHWV4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_e71684d0-7cc1-41b0-ae0e-d210c985750d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Utah's Hogle Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2600 Sunnyside Ave S, Salt Lake City, UT 84108, USA",
      "poi_short_description": "Zoo with 800+ animals, including elephants, giraffes, and polar bears, plus rides and play areas.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including a baby gorilla, polar bears, and zebras, and features a fun carousel and train. They highlight the well-maintained enclosures, the easy walkability, and the educational opportunities, such as keeper talks and animal encounters. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-5cbc-7078-8b88-35d7d17b1a47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-5cbc-7078-8b88-35d7d17b1a47",
        "storage_key": "property/6286356741357568/019d01a4-5cbc-7078-8b88-35d7d17b1a47.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hoglezoo.org/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8354643522834437222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "utahs-hogle-zoo",
      "poi_latitude": "40.7503666",
      "poi_longitude": "-111.8141741",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 801-584-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJidxheRv1UocRZpSQ6wSo8XM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_512ec1ef-ddf4-4f1d-97e1-41229d7b01d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Rice-Eccles Stadium",
      "poi_type": "Entertainment",
      "poi_address": "451 1400 E, Salt Lake City, UT 84112, USA",
      "poi_short_description": "Venue hosting sporting events, including the University of Utah's football team, concerts, and the 2002 Olympic ceremonies.",
      "poi_long_description": "People say this stadium offers a fun experience for concerts, football games, and supercross events. They highlight the massive setups, good acoustics, and beautiful mountain views. They also like the easy access via the tram and the clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-5f8d-718d-9261-56c1cf2e0980.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-5f8d-718d-9261-56c1cf2e0980",
        "storage_key": "property/6286356741357568/019d01a4-5f8d-718d-9261-56c1cf2e0980.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.stadium.utah.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3272348895612041084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "rice-eccles-stadium",
      "poi_latitude": "40.75975",
      "poi_longitude": "-111.8490319",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-581-5445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9789-70d9-8f3d-479cadddaf04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9789-70d9-8f3d-479cadddaf04",
        "storage_key": "property/6286356741357568/019d01a4-9789-70d9-8f3d-479cadddaf04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT68eF_NfUocRfPcYoPu3aS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1f05ce0b-286d-475c-9e88-b86a8e273aa7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Natural History Museum of Utah",
      "poi_type": "Entertainment",
      "poi_address": "301 Wakara Way, Salt Lake City, UT 84108, USA",
      "poi_short_description": "Natural history museum with paleontology and anthropology exhibits, plus state-of-the-art research facilities.",
      "poi_long_description": "People say this natural history museum offers extensive exhibits about biology, geology, and paleontology, including dinosaur bones, fossils, and gems and minerals. They highlight the interactive exhibits, the rotating special exhibits, and the breathtaking views of the city and mountains. They also like the family-friendly atmosphere and the knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-63f5-700c-b89b-0dd7cf28419f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-63f5-700c-b89b-0dd7cf28419f",
        "storage_key": "property/6286356741357568/019d01a4-63f5-700c-b89b-0dd7cf28419f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nhmu.utah.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16883338492971324750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "natural-history-museum-of-utah",
      "poi_latitude": "40.7641297",
      "poi_longitude": "-111.8226881",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 801-581-6927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-97ac-72c6-9a0a-34d5efe6f1ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-97ac-72c6-9a0a-34d5efe6f1ac",
        "storage_key": "property/6286356741357568/019d01a4-97ac-72c6-9a0a-34d5efe6f1ac.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJG1SOiItfUocRThU8WOiqTeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_11e1de04-eaf6-401f-90e5-08e4a9df95d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "515 S 700 E, Salt Lake City, UT 84102, USA",
      "poi_short_description": "High-value gym offering cardio and strength-training equipment, plus group fitness classes.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment, including free weights, resistance machines, and cardio machines, as well as amenities like saunas and massage chairs. They also highlight the affordable membership options, the convenient 24/7 access, and the friendly and helpful staff.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-65ce-770e-9c7b-7fbc90630f45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-65ce-770e-9c7b-7fbc90630f45",
        "storage_key": "property/6286356741357568/019d01a4-65ce-770e-9c7b-7fbc90630f45.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/salt-lake-city-s-700-e-500-s/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14535606599363472597&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "40.7578479",
      "poi_longitude": "-111.8703661",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-850-9810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ625mDen1UocR1SzibTDZuMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f4d2f0d6-3eed-4ea6-bc87-4a3ee427b01b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "MedVet Salt Lake City",
      "poi_type": "Health and Wellness",
      "poi_address": "331 W Bearcat Dr, Salt Lake City, UT 84115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-6b61-75c8-a47e-639556373d4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-6b61-75c8-a47e-639556373d4c",
        "storage_key": "property/6286356741357568/019d01a4-6b61-75c8-a47e-639556373d4c.webp",
        "width": 1024,
        "height": 1025
      },
      "poi_business_url": "https://www.medvet.com/location/salt-lake-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9152040258644601329&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "medvet-salt-lake-city",
      "poi_latitude": "40.7191329",
      "poi_longitude": "-111.9001756",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 385-341-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQbBfbKLUocR8emVKiCUAn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_fa52804b-68ee-493b-8063-8971147359d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1172 Brickyard Rd, Salt Lake City, UT 84106, USA",
      "poi_short_description": "Chain fitness center offering a spacious layout, personal training, and a range of classes.",
      "poi_long_description": "People say this gym offers a variety of equipment, classes, and amenities, including a pool, hot tub, and sauna, and has friendly and helpful staff.\n\nOther reviews mention the gym can be crowded and the membership cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-6b93-76ef-a183-9e843cf59c2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-6b93-76ef-a183-9e843cf59c2a",
        "storage_key": "property/6286356741357568/019d01a4-6b93-76ef-a183-9e843cf59c2a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ut/brickyard/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8228090890031575762&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "40.7011744",
      "poi_longitude": "-111.8583855",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-484-8786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3yH-3X-KUocR0rL19xENMHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_631b89a0-7e88-44f9-8985-6881d03b9f22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "635 E 3300 S, Salt Lake City, UT 84106, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, tanning beds, and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-6b2d-7192-b0c7-49ebbcabe722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-6b2d-7192-b0c7-49ebbcabe722",
        "storage_key": "property/6286356741357568/019d01a4-6b2d-7192-b0c7-49ebbcabe722.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-salt-lake-city-ut?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=889767685976005286&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.7006692",
      "poi_longitude": "-111.8733713",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-467-6711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsQyfLglhUocRppo4B_8WWQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b42cc650-cbb6-403a-ba3c-004cd7697f1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Salt Lake Tennis & Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2471 S 1700 E, Salt Lake City, UT 84106, USA",
      "poi_short_description": "Health club with tennis and swimming facilities, plus a gym, classes, and daycare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-7202-730b-bcfc-6776f1707ebb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-7202-730b-bcfc-6776f1707ebb",
        "storage_key": "property/6286356741357568/019d01a4-7202-730b-bcfc-6776f1707ebb.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://saltlaketennisandhealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5105176662547665736&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "salt-lake-tennis--health-club",
      "poi_latitude": "40.7175895",
      "poi_longitude": "-111.840137",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-487-3206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGzsq1TtgUocRSJPETiA72UY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a6294b44-e83f-452c-986d-c6a992d9f309",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Intermountain Health LDS Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "8th Ave, C St E, Salt Lake City, UT 84143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-721e-7476-be60-bf367b298654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-721e-7476-be60-bf367b298654",
        "storage_key": "property/6286356741357568/019d01a4-721e-7476-be60-bf367b298654.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/lds-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=2659205804862327663&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "intermountain-health-lds-hospital",
      "poi_latitude": "40.7784879",
      "poi_longitude": "-111.8803369",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 801-408-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-989a-748d-94d7-056da0bfc6ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-989a-748d-94d7-056da0bfc6ea",
        "storage_key": "property/6286356741357568/019d01a4-989a-748d-94d7-056da0bfc6ea.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14_kWJ_1UocRb8t5J5dl5yQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9841be11-e43a-4e1a-8b2e-4ec2706901b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "St. Mark's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 E 3900 S, Millcreek, UT 84124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-7432-750f-901c-3543c5071e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-7432-750f-901c-3543c5071e12",
        "storage_key": "property/6286356741357568/019d01a4-7432-750f-901c-3543c5071e12.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.mountainstar.com/locations/st-marks-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12805511169938469049&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "st-marks-hospital",
      "poi_latitude": "40.6860556",
      "poi_longitude": "-111.8570285",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-268-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-989a-748d-94d7-056da0bfc6ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-989a-748d-94d7-056da0bfc6ea",
        "storage_key": "property/6286356741357568/019d01a4-989a-748d-94d7-056da0bfc6ea.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVR-5IEVhUocRubB6A5BQtrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_87620d21-0ce6-4b0c-a3db-500bf30d19c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Liberty Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Harvey Milk Blvd, Salt Lake City, UT 84105, USA",
      "poi_short_description": "Park with a playground, picnic tables, and paddle boats, plus sports facilities and an aviary.",
      "poi_long_description": "People say this park offers a variety of activities, including an aviary, paddle boats, tennis courts, and a pool, as well as walking paths, picnic areas, and a playground. They highlight the park's peaceful and relaxing vibe, and its spaciousness with plenty of shade and benches. They also like the vendors selling trinkets and the drum circles. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-7905-70d9-9827-98d3bcabb848.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-7905-70d9-9827-98d3bcabb848",
        "storage_key": "property/6286356741357568/019d01a4-7905-70d9-9827-98d3bcabb848.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.slc.gov/parks/parks-division/liberty-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3840677276212609488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "liberty-park",
      "poi_latitude": "40.7457045",
      "poi_longitude": "-111.8739202",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-972-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9bfd-71df-b0cb-893d0aaead43",
        "storage_key": "property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZy8zJUT1UocR0EGRSaLTTDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1e9569ee-7663-4591-9c46-247e188bb230",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Sugar House Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1330 2100 S, Salt Lake City, UT 84106, USA",
      "poi_short_description": "Large, 110-acre green space with mature trees, a pond, and areas for basketball, tennis, volleyball, and biking.",
      "poi_long_description": "People say this park offers a lake, pond, creek, and river, as well as trails for walking, jogging, and biking, and open spaces for picnics, sports, and relaxation. They highlight the peaceful and tranquil vibe, and the beautiful mountain views. They also like the dog-friendly environment and the availability of pavilions and playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-78c4-7611-9bcd-334585730ac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-78c4-7611-9bcd-334585730ac5",
        "storage_key": "property/6286356741357568/019d01a4-78c4-7611-9bcd-334585730ac5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sugarhousepark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9609012369130441100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "sugar-house-park",
      "poi_latitude": "40.723877",
      "poi_longitude": "-111.8493998",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 385-468-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9bfd-71df-b0cb-893d0aaead43",
        "storage_key": "property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2EFiCJgUocRjMlayNYRWoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7a055a28-c030-4bf5-ad7e-b6ae698bdcad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Red Butte Garden and Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Wakara Way, Salt Lake City, UT 84108, USA",
      "poi_short_description": "Botanical garden with themed gardens, hiking trails, a concert venue, and educational programs.",
      "poi_long_description": "University of Utah's botanical garden features nature trails, workshops & an outdoor concert series.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-7aa9-71db-8412-35b295fd97a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-7aa9-71db-8412-35b295fd97a4",
        "storage_key": "property/6286356741357568/019d01a4-7aa9-71db-8412-35b295fd97a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redbuttegarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16232989996537460657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "red-butte-garden-and-arboretum",
      "poi_latitude": "40.7661478",
      "poi_longitude": "-111.8247707",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 801-585-0556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9bfd-71df-b0cb-893d0aaead43",
        "storage_key": "property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XwuVcJfUocRsbcVUmUqR-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_40634f26-0898-4c53-9af8-240da0217e85",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "This Is The Place Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2601 Sunnyside Ave S, Salt Lake City, UT 84108, USA",
      "poi_short_description": "Visitors to this park can experience the Old West through train rides, gold panning, and a petting zoo, plus historical exhibits.",
      "poi_long_description": "People say this state park offers a variety of activities, including panning for gold, pony rides, and leather stamping, and features a gift shop, a monument, and historic buildings. They highlight the educational and fun experience for kids, and the beautiful grounds and views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-7cd1-77c8-899b-298d31e11982.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-7cd1-77c8-899b-298d31e11982",
        "storage_key": "property/6286356741357568/019d01a4-7cd1-77c8-899b-298d31e11982.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thisistheplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16090868871749510884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "this-is-the-place-heritage-park",
      "poi_latitude": "40.7520271",
      "poi_longitude": "-111.8162017",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 801-582-1847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9bfd-71df-b0cb-893d0aaead43",
        "storage_key": "property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxRE0iteUocR5CYFXPw_Tt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_5d26f90c-e841-4cdd-8662-52b9487931a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Murray Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "296 E Murray Park Ave, Murray, UT 84107, USA",
      "poi_short_description": "Public park with picnic areas and pavilions, plus athletic courts and fields, and a playground.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, walking paths, a creek, a river, a pool, and pavilions. They highlight the peaceful and fun vibe, and the spacious layout with plenty of parking. They also like the farmers market and the opportunities for picnics and outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-8319-7761-a2de-dbf2c77ae9b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-8319-7761-a2de-dbf2c77ae9b5",
        "storage_key": "property/6286356741357568/019d01a4-8319-7761-a2de-dbf2c77ae9b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://murray.utah.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242524381665348101&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "murray-park",
      "poi_latitude": "40.6591377",
      "poi_longitude": "-111.8821343",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-264-2614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9bfd-71df-b0cb-893d0aaead43",
        "storage_key": "property/6286356741357568/019d01a4-9bfd-71df-b0cb-893d0aaead43.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2gVciGKUocRBcrsiVdVPhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1fdd44cb-39ef-46bb-a1eb-3260d27d6053",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Salt Lake Central Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "340 S 600 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-831e-7679-9964-04216416a37f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-831e-7679-9964-04216416a37f",
        "storage_key": "property/6286356741357568/019d01a4-831e-7679-9964-04216416a37f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621207170146558561&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "salt-lake-central-station",
      "poi_latitude": "40.76233999999999",
      "poi_longitude": "-111.909052",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9bf8-73bc-b1e5-3a8d2830db13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9bf8-73bc-b1e5-3a8d2830db13",
        "storage_key": "property/6286356741357568/019d01a4-9bf8-73bc-b1e5-3a8d2830db13.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJESbRafz0UocRYeIS4m_TIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e6c7d121-4a2b-4d0f-8624-1bece5dd2a72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "North Temple Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Salt Lake City, UT 84103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-8311-749b-965d-8be4606e4393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-8311-749b-965d-8be4606e4393",
        "storage_key": "property/6286356741357568/019d01a4-8311-749b-965d-8be4606e4393.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17090140258902178030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "north-temple-station",
      "poi_latitude": "40.7727569",
      "poi_longitude": "-111.905134",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9bf8-73bc-b1e5-3a8d2830db13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9bf8-73bc-b1e5-3a8d2830db13",
        "storage_key": "property/6286356741357568/019d01a4-9bf8-73bc-b1e5-3a8d2830db13.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQo10FT0UocR7nh3nQRgLO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_fd6b4da7-80e0-434c-8f15-3c08dcc7c456",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Murray Central Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Murray, UT 84107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-8974-7199-bfae-d5a443968430.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-8974-7199-bfae-d5a443968430",
        "storage_key": "property/6286356741357568/019d01a4-8974-7199-bfae-d5a443968430.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16241260686819676830&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "murray-central-station",
      "poi_latitude": "40.6597775",
      "poi_longitude": "-111.8955845",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzHuJymKUocRnlJndouMZOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c58717c2-4ebb-4365-87e8-f3aa38f8bcad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Central Pointe Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "South Salt Lake, UT 84115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-898d-74ef-b682-caa5d599e49f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-898d-74ef-b682-caa5d599e49f",
        "storage_key": "property/6286356741357568/019d01a4-898d-74ef-b682-caa5d599e49f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6072243359573750996&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "central-pointe-station",
      "poi_latitude": "40.7246379",
      "poi_longitude": "-111.8968839",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-743-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNzXRlNCKUocR1DQe1SnxRFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_609ed986-b291-468e-9af8-9f014860f294",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "L3Harris Technologies: Communication Systems-West",
      "poi_type": "Major Employers & Offices",
      "poi_address": "640 N 2200 W, Salt Lake City, UT 84116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-8a81-7109-8dbf-190099bac330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-8a81-7109-8dbf-190099bac330",
        "storage_key": "property/6286356741357568/019d01a4-8a81-7109-8dbf-190099bac330.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://l3harris.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18300702297262212660&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "l3harris-technologies-communication-systems-west",
      "poi_latitude": "40.7835508",
      "poi_longitude": "-111.9523593",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-594-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpUnzcgr0UocRNEZ9MMcn-f0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6730e048-fa38-475d-9fd1-31f86b1982a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Varex Imaging Visitor Entrance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1678 Pioneer Rd, Salt Lake City, UT 84104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-8a1f-7391-aaa7-28f5041a9eaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-8a1f-7391-aaa7-28f5041a9eaf",
        "storage_key": "property/6286356741357568/019d01a4-8a1f-7391-aaa7-28f5041a9eaf.webp",
        "width": 909,
        "height": 634
      },
      "poi_business_url": "http://www.vareximaging.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2741201802850912740&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "varex-imaging-visitor-entrance",
      "poi_latitude": "40.7332053",
      "poi_longitude": "-111.9591313",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-972-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRP7vFvzUocR5MmWJIS0CiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1af004a2-98b2-4f18-b188-c62fea33ba8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Salt Lake City and County Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "451 S State St, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Victorian-era city hall noted for its iconic 256-foot clock tower & carved gray sandstone facade.",
      "poi_long_description": "Victorian-era city hall noted for its iconic 256-foot clock tower & carved gray sandstone facade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-8f77-74c2-8cd2-d0893d1df35c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-8f77-74c2-8cd2-d0893d1df35c",
        "storage_key": "property/6286356741357568/019d01a4-8f77-74c2-8cd2-d0893d1df35c.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "http://www.slc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=726748788876054070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "salt-lake-city-and-county-building",
      "poi_latitude": "40.75952720000001",
      "poi_longitude": "-111.8870898",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-535-7704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9bfb-764c-96e8-62e8589aa59b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9bfb-764c-96e8-62e8589aa59b",
        "storage_key": "property/6286356741357568/019d01a4-9bfb-764c-96e8-62e8589aa59b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWXpWBH1UocRNg7nSSzuFQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_6856744d-c666-448f-82a6-f28d63595083",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "Recursion",
      "poi_type": "Major Employers & Offices",
      "poi_address": "41 N 400 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-8f84-71dd-a56d-677b285a205a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-8f84-71dd-a56d-677b285a205a",
        "storage_key": "property/6286356741357568/019d01a4-8f84-71dd-a56d-677b285a205a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.recursion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8839530553745273717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "recursion",
      "poi_latitude": "40.768436",
      "poi_longitude": "-111.9027612",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 385-269-0203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJterm5MVfUocRdfMybTRSrHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_84386c1b-23f8-4b5b-822d-be8f88775892",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "poi_name": "INDUSTRY SLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "650 S 500 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9044-77bb-9448-e525eaef0dd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a4-9044-77bb-9448-e525eaef0dd5",
        "storage_key": "property/6286356741357568/019d01a4-9044-77bb-9448-e525eaef0dd5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.industryoffice.com/slc",
      "poi_directions_map_url": "https://maps.google.com/?cid=318628017020505743&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "industry-slc",
      "poi_latitude": "40.7551242",
      "poi_longitude": "-111.9057491",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a4-9772-72c7-ab4e-f2dcd2914544",
        "storage_key": "property/6286356741357568/019d01a4-9772-72c7-ab4e-f2dcd2914544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX3Xt0v1UocRj47-SX7-awQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_ce46dc1034548ae1a0e2aaaa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_17e80c3c5a8a6c54af157dab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f96cbb2ddf2bbd836cd8ab2e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8695b9306f9c563f4fcaa553",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fe15ad3f379798641d8f2a46",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_36c20bd0b029860871219de1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "rating": "5",
      "name": "Jessica Tibbitts",
      "text": "Since moving here(August 2024) I have been met with nothing but kindness and respect. Perla and Chris have answered all of my millions of questions and spent their precious time getting to know me and my family. They have been so kind to my dog and they are the highlight of his day. All staff has been super kind and honestly make living here amazing. Reyna does an amazing job with cleaning and does it all with a smile on her face. I would highly recommend moving here if you want a family friendly atmosphere and kind company.",
      "date": "2025-02-14",
      "title": "false"
    },
    {
      "id": "ec_1bf12a477ea73f91f7937970",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "rating": "5",
      "name": "ladilyn nava",
      "text": "A pleasant environment for living peacefully and receiving the best service. They are truly efficient. There is ample communication via email and phone for the Ritz Classic community. The attention to residents is very kind from Mrs. Cris and Perla. They were always concerned about providing good care and solutions to the residents' needs. I truly congratulate them; we are 100% grateful for their attention, and I hope they continue to do so. The housekeeper is phenomenal. The bathrooms, gym, elevators, and everything are impeccable. Thank you for making my family happy all this time. I wish you blessings.",
      "date": "2025-06-04",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_fbfcb4a2-5110-4c29-a29f-ec509a6b9a63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019fd3a2-e479-71e8-97e4-5d5bb86e3aab.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-e479-71e8-97e4-5d5bb86e3aab",
        "storage_key": "property/6286356741357568/019fd3a2-e479-71e8-97e4-5d5bb86e3aab.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Studio, 1BA - Lilly",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XP6fz3RN224&play=1"
    },
    {
      "id": "custom_39ff2998-96b1-40b0-8e1b-dd1ad461ddef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019ddcc7-5358-749d-bb20-1eb988c0de1e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-5358-749d-bb20-1eb988c0de1e",
        "storage_key": "property/6286356741357568/019ddcc7-5358-749d-bb20-1eb988c0de1e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Clover",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rVgwYUVzgq8&play=1"
    },
    {
      "id": "custom_53f82cff-7f13-4a4d-b1bb-ae36d8115e84",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019fd3a2-e6b0-74d1-8afa-e7ea1d700d0a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-e6b0-74d1-8afa-e7ea1d700d0a",
        "storage_key": "property/6286356741357568/019fd3a2-e6b0-74d1-8afa-e7ea1d700d0a.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "1BR, 1BA - Clover",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=x6Am3DegpZp&play=1"
    },
    {
      "id": "custom_37c8fe00-7546-49e0-99e1-554d4adf96ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019ddcc7-52eb-723f-8c7d-250ac19334e3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-52eb-723f-8c7d-250ac19334e3",
        "storage_key": "property/6286356741357568/019ddcc7-52eb-723f-8c7d-250ac19334e3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - Brooklyn",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=APDccyZkJdn&play=1"
    },
    {
      "id": "custom_43da9cff-9b13-4d4c-8566-fe3b42e1e51f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019ddcc7-5358-749d-bb20-1b5adbab8fef.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-5358-749d-bb20-1b5adbab8fef",
        "storage_key": "property/6286356741357568/019ddcc7-5358-749d-bb20-1b5adbab8fef.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - Jersey",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=H2ZSSz28KwA&play=1"
    },
    {
      "id": "custom_5247e650-7033-4797-89e5-b43b4ad04576",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019ddcc7-529c-750e-98f0-039e7a792b79.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-529c-750e-98f0-039e7a792b79",
        "storage_key": "property/6286356741357568/019ddcc7-529c-750e-98f0-039e7a792b79.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - Kingpin",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hNoR5p1Fcm1&play=1"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_9e2706153f4f80fb65307392",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "6f76c0be71fbbc10",
      "name": "Early Termination Fee",
      "description": "Early Termination Fee",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9cabcf32a4504d2948e7d0f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "a95f720eb096e19d",
      "name": "NSF Tenant Fee",
      "description": "Returned Check Charge",
      "amount": 20,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ee77988c5fe79c2397d4bbc0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "3a70a18b66fedc73",
      "name": "Late Fee",
      "description": "Late Fee - Charged on the 4th of the month",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cbc0a930b67fc89347fefdb0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "156cb047009f8824",
      "name": "Transfer Fee",
      "description": "Fee to transfer apartments",
      "amount": 300,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_de2d7eeb133c7093db345a4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "b4fc7a609c6a024a",
      "name": "Water Charge",
      "description": "Water Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "watr",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7b79809d3e9f354fd1651aa5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "5220ab82da17938b",
      "name": "Trash Charge",
      "description": "Trash Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "garb",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_59ad6c6255471442a6f96262",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "0fe57ea9920b7190",
      "name": "Pest Control Charge",
      "description": "Pest Control Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "pest",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_632b707171095c68a0f44392",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "afa97d5b51573785",
      "name": "Electric Charge",
      "description": "Electric Utility Charge - Only billed through property if utility is not set up with provider",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on usage",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "vcrelec",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_10799ad54fbffc20a93fffdb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "fca9718c6218fc84",
      "name": "Electric Fee",
      "description": "Electric Fee - Only billed to resident if utility is not set up in resident's name.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elecfee",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_47263deb3ffd1844f8b34afe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "89d90f5fb6b1dd0f",
      "name": "Utility Activiation Fee",
      "description": "Fee for setting up utilities",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Move-In",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4078e1e7dbed1eebe36e6565",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "b89f754b1e0fb167",
      "name": "Legal Fee",
      "description": "Fee for legal notices served",
      "amount": 15,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Legal",
      "charge_code": "legl",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a061a41a8924ff0f3d53be61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "43ac70d0b7f9873e",
      "name": "EV Charging Station",
      "description": "Parking for EV Charging",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Parking",
      "charge_code": "garg",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_855bf23f346500c40b205418",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "2465714",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 200,
      "fee": 200,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_ad5447cf23a83b99e3241c29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "yardi",
      "external_id": "2465713",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 45,
      "deposit": 200,
      "fee": 200,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-73d5-75e1-96ea-1b9f9553315e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-ritz-classic",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568"
    },
    {
      "lead_collector_id": "0198aa47-7437-746f-8535-aaa125f6403c",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-ritz-classic",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568"
    },
    {
      "lead_collector_id": "0198aa47-7499-7047-9cf9-dd4d98859911",
      "lead_source": "LANDING_PAGE",
      "name": "the-ritz-classic",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-slc",
      "search_query": "luxury apartments with in-unit laundry salt lake city",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover luxury living in Salt Lake City. Our apartments offer in-unit laundry, along with upscale amenities and versatile floor plans.",
      "page_copy": "Welcome to The Ritz Classic, where luxury meets convenience in the heart of Salt Lake City. Our upscale apartments come equipped with in-unit laundry facilities, allowing you to enjoy the comfort of taking care of your laundry needs right at home. Choose from a range of floor plans—whether it's a cozy studio or a spacious two-bedroom, each space is designed to enhance your lifestyle with premium features and finishes.\n\nBeyond the remarkable in-unit laundry experience, The Ritz Classic offers a variety of top-tier amenities. Dive into relaxation at our pool, rejuvenate at the yoga studio, or challenge yourself in our fitness center outfitted with cardio machines. Not to mention, our pet-friendly community ensures that both you and your furry friends will feel right at home. Schedule a tour today to explore these luxury apartments in Salt Lake City and find your perfect fit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry",
      "seo_description": "Explore luxury apartments with in-unit laundry in Salt Lake City. Enjoy top amenities and elegant living at The Ritz Classic. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-pet-play-area-south-slc",
      "search_query": "dog-friendly apartments with pet play area in south salt lake",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Pet Play Area",
      "h2_subtitle": "Find the perfect pet-friendly home in South Salt Lake. Our apartments include a dedicated pet play area and more amenities for you and your furry friends.",
      "page_copy": "Welcome to The Ritz Classic, the ultimate destination for you and your pet in South Salt Lake. Our dog-friendly apartments feature a dedicated pet play area where your furry companions can run and socialize. Whether you're looking for a cozy studio or a spacious two-bedroom apartment, you'll find the perfect home suited to your lifestyle, complete with premium finishes and features.\n\nBeyond a welcoming environment for pets, The Ritz Classic offers an array of amenities that cater to every need. Relax by the pool, rejuvenate in the yoga studio, or maintain an active lifestyle in our fitness center with cardio machines. With on-site maintenance and a convenient location, you'll experience a seamless living experience. Discover how our South Salt Lake community can become a fantastic home for both you and your four-legged friend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Pet Play Area",
      "seo_description": "Discover dog-friendly apartments with a pet play area in South Salt Lake. Live at The Ritz Classic and enjoy a welcoming environment with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-with-pool-fitness-center-84115",
      "search_query": "apartments with pool and fitness center in 84115",
      "category": "Amenity",
      "h1_title": "Apartments with Pool and Fitness Center",
      "h2_subtitle": "Live in the heart of 84115 with top amenities. Our apartments offer a pool and fitness center, perfect for active lifestyles in Salt Lake City.",
      "page_copy": "Experience unparalleled living at The Ritz Classic in the vibrant area of 84115. Our community features apartments equipped with everything you need, including access to a refreshing pool and a comprehensive fitness center. Whether you prefer swimming laps or working out on state-of-the-art cardio machines, our amenities are designed to support your active lifestyle.\n\nChoose from a variety of floor plans, ranging from studios to two-bedroom layouts, all designed with modern touches and conveniences in mind. Living at The Ritz Classic ensures you’re in the hub of Salt Lake City’s offerings while enjoying luxurious on-site features such as a yoga studio and pet play area. Join us today to discover your perfect home in the dynamic community of 84115.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool and Fitness Center",
      "seo_description": "Explore apartments with a pool and fitness center in 84115. Experience exceptional living at The Ritz Classic in Salt Lake City. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "downtown-slc-apartments-air-conditioning",
      "search_query": "downtown salt lake city apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Downtown SLC Apartments with Air Conditioning",
      "h2_subtitle": "Experience comfort and convenience with air-conditioned living in downtown Salt Lake City. Enjoy stylish apartments with modern amenities.",
      "page_copy": "Located in the vibrant downtown area, The Ritz Classic offers sophisticated living spaces with the comfort of air conditioning. Whether you're unwinding in your studio or entertaining in a two-bedroom apartment, you can enjoy perfect climate control year-round. Each apartment is thoughtfully designed with upscale finishes and functional floor plans, ensuring a seamless blend of style and comfort.\n\nOur community is more than just a place to live; it’s a lifestyle. Indulge in amenities such as a sparkling pool, a dynamic fitness center, and a tranquil yoga studio. Additionally, our on-site maintenance and friendly staff ensure a hassle-free living experience. All of this is conveniently situated in downtown Salt Lake City, giving you easy access to dining, entertainment, and cultural attractions. Make The Ritz Classic your home today and enjoy the perfect downtown living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown SLC Apartments with Air Conditioning",
      "seo_description": "Explore air-conditioned apartments in downtown Salt Lake City. Discover comfortable living at The Ritz Classic with modern amenities. Schedule a visit now.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-parking-garage-salt-lake-city",
      "search_query": "apartments with dishwasher and parking garage salt lake city",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher and Parking Garage",
      "h2_subtitle": "Discover convenience in Salt Lake City with apartments featuring a dishwasher and parking garage. Modern living at its finest at The Ritz Classic.",
      "page_copy": "The Ritz Classic offers an ideal living experience in Salt Lake City, where modern conveniences meet urban charm. Our apartments are equipped with dishwashers, making kitchen cleanup quick and easy, and we also provide a secure parking garage for hassle-free commuting and peace of mind. From studios to spacious two-bedroom layouts, each apartment is designed with comfort and style, ensuring a warm and welcoming environment.\n\nIn addition to essential in-home features, residents enjoy an array of community amenities. Spend your free time by the pool, exercise in our well-equipped fitness center, or unwind in the yoga studio. Located close to all that Salt Lake City has to offer, The Ritz Classic provides a vibrant community atmosphere with the conveniences of city living. Visit us today and find your ideal home that caters to every need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher & Parking Garage",
      "seo_description": "Find apartments with a dishwasher and parking garage in Salt Lake City. Live at The Ritz Classic and enjoy modern conveniences and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "studio-apartments-south-salt-lake-city",
      "search_query": "studio apartments south salt lake city",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in South Salt Lake City",
      "h2_subtitle": "Find your perfect studio apartment in South Salt Lake City. Enjoy modern living with top amenities at The Ritz Classic.",
      "page_copy": "Discover the ideal studio apartment at The Ritz Classic, nestled in the vibrant South Salt Lake City neighborhood. Our studios are thoughtfully designed to maximize space and functionality, providing a comfortable living experience with modern finishes. Each apartment is equipped with beautiful hardwood floors and top-tier appliances, making it easy to settle in and feel at home.\n\nBeyond the interior comforts, The Ritz Classic offers a host of amenities tailored to meet diverse lifestyle needs. Enjoy convenient access to our fitness center and unwind in the serene atmosphere of our yoga studio. A pet play area ensures that furry friends feel at home, too. Situated in a prime location, residents have easy access to all that South Salt Lake City and the greater area have to offer, including dining, shopping, and cultural attractions. Seize the opportunity to live in an inviting community that truly feels like home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in South Salt Lake City",
      "seo_description": "Explore studio apartments in South Salt Lake City at The Ritz Classic. Enjoy modern living with amazing amenities. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-salt-lake-city-ut",
      "search_query": "1 bedroom apartments in salt lake city ut",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Salt Lake City, UT",
      "h2_subtitle": "Explore stylish 1 bedroom apartments in Salt Lake City, UT. Enjoy modern amenities and prime location at The Ritz Classic.",
      "page_copy": "The Ritz Classic provides an exquisite selection of 1 bedroom apartments perfect for those seeking a blend of comfort and modernity in Salt Lake City, UT. Each apartment is stylishly appointed, featuring hardwood floors and ample living space, ensuring you feel right at home. These units are designed for ultimate convenience, complete with contemporary kitchen appliances and spacious layouts.\n\nAs part of the vibrant Ritz Classic community, residents enjoy exclusive access to a wide range of amenities. Take a dip in the pool, stay active in the fully-equipped fitness center, or find peace in the serene yoga studio. Situated in a lively part of Salt Lake City, our location provides easy access to shopping, dining, and entertainment options. Discover the convenience and luxury of living at The Ritz Classic, where every day feels exceptional.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Salt Lake City, UT",
      "seo_description": "Find stylish 1 bedroom apartments in Salt Lake City, UT at The Ritz Classic. Enjoy premium amenities and a prime location. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-84115",
      "search_query": "2 bedroom apartments near 84115",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 84115",
      "h2_subtitle": "Discover spacious 2 bedroom apartments near the 84115 area. Experience modern living and top amenities at The Ritz Classic.",
      "page_copy": "Looking for a comfortable and spacious living space near the 84115 area? Explore our beautifully designed 2 bedroom apartments at The Ritz Classic. Each apartment offers generous living quarters complemented by stylish interiors and high-quality finishes, including sleek hardwood flooring. Modern kitchens with energy-efficient appliances enhance each unit’s appeal, making daily living a breeze.\n\nOur community goes beyond just great apartments with a range of amenities designed to enrich your lifestyle. Dive into relaxation at our sparkling pool, maintain an active lifestyle at our state-of-the-art fitness center, or indulge in tranquility at our yoga studio. Situated in a dynamic part of Salt Lake City, The Ritz Classic offers the perfect balance of local conveniences and residential tranquility. Join our community today and elevate your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 84115",
      "seo_description": "Discover spacious 2 bedroom apartments near 84115 at The Ritz Classic. Enjoy top amenities and a vibrant community. Schedule a visit today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-utah-salt-lake-city",
      "search_query": "apartments near university of utah salt lake city",
      "category": "School",
      "h1_title": "Apartments Near University of Utah, SLC",
      "h2_subtitle": "Discover stylish apartments near the University of Utah in Salt Lake City. Experience premium living with modern amenities at The Ritz Classic.",
      "page_copy": "For those seeking a dynamic living environment close to the University of Utah in Salt Lake City, The Ritz Classic offers the perfect solution. Our community features thoughtfully designed apartments that blend style and comfort seamlessly. With options ranging from studios to two-bedroom layouts, each apartment includes modern appliances and sleek hardwood floors, creating an inviting and functional living space.\n\nThe Ritz Classic is more than just a place to live; it's a lifestyle. Residents enjoy access to a range of premium amenities including a refreshing pool, fully-equipped fitness center, and a calming yoga studio. Nestled in a prime Salt Lake City location, our community provides quick access to the University of Utah and other nearby attractions, making it an ideal choice for students, staff, and professionals. Explore a vibrant community that provides both convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Utah, SLC",
      "seo_description": "Find premium apartments near the University of Utah in Salt Lake City at The Ritz Classic. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-close-to-salt-lake-community-college-taylorsville",
      "search_query": "apartments close to salt lake community college taylorsville",
      "category": "School",
      "h1_title": "Apartments Near Salt Lake Community College",
      "h2_subtitle": "Explore stylish apartments close to Salt Lake Community College in Taylorsville. Enjoy great amenities and a welcoming community at The Ritz Classic.",
      "page_copy": "Discover convenient and comfortable living at The Ritz Classic, perfectly situated near Salt Lake Community College's Taylorsville campus. Our community offers a variety of apartment floor plans that cater to diverse needs, ensuring you'll find a home that suits your lifestyle. Enjoy living in stylish interiors featuring hardwood floors and modern kitchen appliances, all designed for comfortable and efficient living.\n\nAt The Ritz Classic, you'll have access to a range of premium amenities designed to enhance your lifestyle. Take a refreshing dip in the pool, work out in our comprehensive fitness center, or relax in the tranquil yoga studio. Located in the vibrant area of South Salt Lake City, our community provides easy access to the college and nearby attractions, making it a prime choice for students and professionals alike. Experience the perfect blend of convenience and comfort today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Salt Lake Community College",
      "seo_description": "Find convenient apartments near Salt Lake Community College Taylorsville at The Ritz Classic. Enjoy modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "ensign-college-nearby-apartments-south-salt-lake-city",
      "search_query": "ensign college nearby apartments south salt lake city",
      "category": "School",
      "h1_title": "Apartments Near Ensign College, South SLC",
      "h2_subtitle": "Find nearby apartments to Ensign College in South Salt Lake City. Experience upscale living at The Ritz Classic with convenient amenities.",
      "page_copy": "If you are looking for comfortable and modern living close to Ensign College in South Salt Lake City, The Ritz Classic is an ideal choice. Our selection of studio, one, and two-bedroom apartments offers exceptional living spaces with elegant features such as hardwood floors and contemporary appliances, ensuring a stylish and functional home.\n\nBeyond beautifully designed apartments, The Ritz Classic offers an array of amenities that inspire a vibrant lifestyle. Residents can enjoy a dip in our serene pool, work out in the state-of-the-art fitness center, or unwind in our tranquil yoga studio. Located conveniently in South Salt Lake City, our community provides quick access to Ensign College, making it perfect for students and professionals seeking both convenience and comfort. Discover the benefits of living in a well-appointed community designed for modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ensign College, South SLC",
      "seo_description": "Explore upscale apartments near Ensign College in South Salt Lake City at The Ritz Classic. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "western-governors-university-ut-apartments",
      "search_query": "western governors university ut apartments",
      "category": "School",
      "h1_title": "Apartments Near Western Governors University UT",
      "h2_subtitle": "Discover stylish apartments perfect for Western Governors University students in UT. Experience modern living at The Ritz Classic.",
      "page_copy": "Situated conveniently for students and staff of Western Governors University in Utah, The Ritz Classic offers a superb living environment. Our community presents a range of apartment homes from studios to two-bedroom layouts that provide a harmonious blend of comfort and style. Each residence features modern appliances and tasteful hardwood floors, creating a welcoming ambiance.\n\nBeyond the comfort of your apartment, enjoy access to premium amenities designed to meet your lifestyle needs. Dive into our sparkling pool, stay fit in the well-equipped fitness center, or find tranquility in the peaceful yoga studio. Located in the vibrant area of South Salt Lake City, The Ritz Classic delivers easy access to Western Governors University along with the city’s attractions, offering a perfect blend of location, luxury, and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Western Governors University UT",
      "seo_description": "Find stylish apartments perfect for Western Governors University UT students at The Ritz Classic. Enjoy modern amenities in South Salt Lake City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-near-intermountain-health-lds-hospital-salt-lake-city",
      "search_query": "apartments near intermountain health lds hospital salt lake city",
      "category": "Hospital",
      "h1_title": "Apartments Near Intermountain Health LDS Hospital",
      "h2_subtitle": "Explore The Ritz Classic, offering convenient apartments near Intermountain Health LDS Hospital in Salt Lake City. Discover modern comforts and amenities.",
      "page_copy": "Living near Intermountain Health's LDS Hospital in Salt Lake City just got easier with The Ritz Classic apartments. Our community features a variety of floor plans, allowing you to select the perfect home that meets your lifestyle needs. Residents enjoy modern interiors with amenities such as hardwood floors, efficient appliances, and spacious living areas designed for comfort and convenience.\n\nThe Ritz Classic not only offers aesthetically pleasing living spaces but also exceptional community amenities. Take advantage of our fitness center, relax by the pool, or unwind in the yoga studio as part of a healthy and active lifestyle. Located in South Salt Lake City, our apartments provide easy access to the hospital as well as the vibrant downtown area. With its prime location and thoughtful design, The Ritz Classic is an excellent choice for medical professionals and anyone seeking quality living close to the city’s amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Intermountain Health LDS Hospital",
      "seo_description": "Discover convenient living near Intermountain Health LDS Hospital at The Ritz Classic in Salt Lake City. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-close-to-st-marks-hospital-south-salt-lake-city",
      "search_query": "apartments close to st. mark's hospital south salt lake city",
      "category": "Hospital",
      "h1_title": "St. Mark's Hospital Nearby Apartments",
      "h2_subtitle": "Find apartments close to St. Mark's Hospital in South Salt Lake City. Enjoy convenient living at The Ritz Classic with top-notch amenities.",
      "page_copy": "If you're searching for apartments close to St. Mark's Hospital in South Salt Lake City, The Ritz Classic is an ideal living solution. We offer a selection of well-designed studios, one-bedroom, and two-bedroom apartments that are perfect for hospital staff and visitors alike. Each apartment comes equipped with modern features and finishes, such as hardwood floors and updated appliances, ensuring a comfortable and stylish home environment.\n\nIn addition to beautifully appointed living spaces, The Ritz Classic boasts a range of impressive amenities. Enjoy our pool, stay active in the fitness center, or take a moment to relax in the yoga studio. Situated in a prime South Salt Lake City location, our community offers convenience and ease of access, making it simple to commute to St. Mark's Hospital or explore the dining and cultural offerings of the city. Experience life at The Ritz Classic, where comfort meets accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to St. Mark's Hospital SLC",
      "seo_description": "Find convenient living near St. Mark's Hospital at The Ritz Classic in South Salt Lake City. Enjoy top amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-near-liberty-park-salt-lake-city",
      "search_query": "apartments near liberty park salt lake city",
      "category": "Park",
      "h1_title": "Apartments Near Liberty Park Salt Lake City",
      "h2_subtitle": "Discover stylish apartments close to Liberty Park in Salt Lake City. Experience modern amenities at The Ritz Classic, your ideal home base.",
      "page_copy": "Nestled close to the vibrant Liberty Park in Salt Lake City, The Ritz Classic offers a serene living space in a bustling urban location. Our apartment community provides a range of floor plans, from cozy studios to spacious two-bedroom homes, each designed to blend comfort with style. Residents can enjoy well-appointed interiors featuring hardwood floors and contemporary appliances.\n\nAt The Ritz Classic, the amenities extend beyond your apartment door. Relax by our sparkling pool, stay fit in our modern fitness center, or unwind in the tranquility of our yoga studio. Positioned in South Salt Lake City, The Ritz Classic offers easy access to the lush sprawling landscapes of Liberty Park while keeping you connected to the city's vibrant happenings. Step into a lifestyle that balances serene living with dynamic city life at The Ritz Classic.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Liberty Park SLC",
      "seo_description": "Explore modern living near Liberty Park at The Ritz Classic in Salt Lake City. Enjoy stylish apartments and amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-close-to-sugar-house-park-slc",
      "search_query": "apartments close to sugar house park SLC",
      "category": "Park",
      "h1_title": "Apartments Near Sugar House Park SLC",
      "h2_subtitle": "Explore The Ritz Classic, offering luxury apartments close to Sugar House Park in SLC. Enjoy modern living and prime access to nature.",
      "page_copy": "For those seeking apartments close to Sugar House Park in SLC, The Ritz Classic presents an ideal living option. Enjoy the perfect blend of urban convenience and natural beauty with our stylish apartment homes, ranging from studios to two-bedroom floor plans. Each apartment is thoughtfully designed to offer comfort and sophistication, featuring updated appliances and exquisite hardwood flooring.\n\nLiving at The Ritz Classic means access to first-rate amenities that enrich your lifestyle. Whether you're lounging by the pool, getting a workout in the fitness center, or finding stillness in our yoga studio, there's something for everyone here. Located in South Salt Lake City, our community offers seamless access to the picturesque Sugar House Park, allowing residents to enjoy outdoor activities and leisure moments just minutes from home. Experience the best of city living combined with nature's touch at The Ritz Classic.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Sugar House Park SLC",
      "seo_description": "Discover luxury living near Sugar House Park at The Ritz Classic in SLC. Enjoy upscale amenities and a top location near natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "rental-homes-near-red-butte-garden-utah",
      "search_query": "rental homes near red butte garden utah",
      "category": "Park",
      "h1_title": "Rental Homes Near Red Butte Garden Utah",
      "h2_subtitle": "Find charming rental homes near Red Butte Garden in Utah. Enjoy modern comforts at The Ritz Classic, your gateway to nature and the city.",
      "page_copy": "Experience the beauty and tranquility of nature with rental homes near Red Butte Garden in Utah by choosing The Ritz Classic. Our community offers a range of thoughtfully designed apartments, from cozy studios to spacious two-bedroom homes, each equipped with modern features like hardwood floors and high-end appliances. These homes are ideal for anyone looking to balance city living with nature's serenity.\n\nThe Ritz Classic provides various amenities that cater to both relaxation and fitness. Dive into our refreshing pool, maintain your exercise routine at the fitness center, or enjoy peaceful meditation in the yoga studio. Located in South Salt Lake City, our community not only places you close to the botanical wonders of Red Butte Garden but also provides easy access to the dynamic offerings of urban life. Discover a harmonious blend of nature and modernity at The Ritz Classic.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Red Butte Garden Utah",
      "seo_description": "Explore rental homes near Red Butte Garden at The Ritz Classic in Utah. Experience modern amenities and a location blending nature with city life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "living-near-this-is-the-place-heritage-park",
      "search_query": "living near this is the place heritage park",
      "category": "Park",
      "h1_title": "Living Near This Is The Place Heritage Park",
      "h2_subtitle": "Experience living near This Is The Place Heritage Park with modern comforts. The Ritz Classic offers the perfect mix of convenience and culture.",
      "page_copy": "Discover the unique lifestyle of living near This Is The Place Heritage Park at The Ritz Classic. Perfectly situated in South Salt Lake City, our community offers easy access to cultural landmarks combined with modern living quarters. Choose from a variety of layouts, including studios and two-bedroom apartments, each thoughtfully designed with features such as elegant hardwood floors and contemporary conveniences.\n\nResidents of The Ritz Classic enjoy premium amenities that elevate everyday living. Take advantage of our state-of-the-art fitness center, immerse yourself in the serenity of our yoga studio, or socialize at our inviting coffee bar. While located near the historic allure of This Is The Place Heritage Park, our community also provides easy access to Salt Lake City's vibrant offerings. Make The Ritz Classic your home for a lifestyle enriched with culture and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near This Is The Place Heritage Park",
      "seo_description": "Enjoy living near This Is The Place Heritage Park at The Ritz Classic in SLC. Experience cultural proximity and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartment-rentals-close-to-murray-park-south-salt-lake",
      "search_query": "apartment rentals close to murray park south salt lake city",
      "category": "Park",
      "h1_title": "Apartment Rentals Near Murray Park SLC",
      "h2_subtitle": "Discover apartment rentals close to Murray Park in South Salt Lake City. The Ritz Classic offers a perfect blend of comfort and convenience.",
      "page_copy": "If you're searching for apartment rentals close to Murray Park in South Salt Lake City, The Ritz Classic is your ideal destination. Located just a short drive from the beautiful Murray Park, our apartment community provides the best of both urban convenience and natural beauty. Choose from various floor plans, including chic studios and spacious two-bedroom homes, complemented by modern finishes and stylish designs.\n\nAt The Ritz Classic, residents enjoy an array of amenities designed to enhance their lifestyle. Relax by the sparkling pool, stay active with top-notch cardio machines in the fitness center, or unwind in the tranquil yoga studio. Our community's prime location offers easy access to outdoor recreation at Murray Park while ensuring you're never far from the cultural and dining experiences of Salt Lake City. Experience exceptional apartment living at The Ritz Classic.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Rentals Close to Murray Park SLC",
      "seo_description": "Explore apartment rentals near Murray Park at The Ritz Classic. Enjoy the blend of nature and city living in South Salt Lake City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "apartments-near-murray-central-station-ut",
      "search_query": "apartments near Murray Central Station UT",
      "category": "Transit",
      "h1_title": "Apartments Near Murray Central Station UT",
      "h2_subtitle": "Explore apartments near Murray Central Station UT. The Ritz Classic offers connectivity and modern living in a vibrant community.",
      "page_copy": "For those seeking convenience and connectivity, The Ritz Classic offers apartments near Murray Central Station UT, ensuring easy access to public transportation and city life. Whether you're commuting for work or exploring Salt Lake City's vibrant neighborhoods, our ideal location makes traveling a breeze. Choose from a selection of expertly designed studios to expansive two-bedroom apartments, each featuring modern amenities and stylish finishes.\n\nAt The Ritz Classic, you'll find everything you need for a fulfilling lifestyle. Unwind at our sparkling pool, stay energized in our state-of-the-art fitness center, or find relaxation and balance in our serene yoga studio. Located in the lively South Salt Lake City area, our community combines the ease of urban living with a welcoming atmosphere. Choose The Ritz Classic for a home that offers both convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Murray Central Station UT",
      "seo_description": "Find apartments near Murray Central Station at The Ritz Classic. Enjoy modern living and easy transit in our South Salt Lake City community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6286356741357568",
      "source": "generator",
      "page_item_url": "south-salt-lake-city-apartments-central-pointe-station",
      "search_query": "South Salt Lake City apartments close to Central Pointe Station",
      "category": "Transit",
      "h1_title": "Apartments Near Central Pointe Station SLC",
      "h2_subtitle": "Discover South Salt Lake City apartments close to Central Pointe Station. The Ritz Classic combines urban living with top-tier amenities.",
      "page_copy": "For those seeking South Salt Lake City apartments close to Central Pointe Station, The Ritz Classic offers an unbeatable location with unparalleled convenience. Situated near the heart of transit connectivity, our community provides seamless access to all that Salt Lake City has to offer. Choose from a variety of floor plans, including stylish studios to spacious two-bedroom units, each thoughtfully designed with top-notch finishes and features.\n\nResidents at The Ritz Classic enjoy a wealth of amenities that cater to a modern lifestyle. Whether you want to invigorate your day at the fitness center, refresh yourself with a dip in the pool, or unwind in the calming atmosphere of our yoga studio, there's something for everyone. Located just moments from Central Pointe Station, our community ensures minimal transit times and maximized enjoyment of city life with ease and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, open to a living area with sofa and coffee table.",
        "public_id": "019d01a4-3355-740f-8d8b-ce1ebfaebc4b",
        "storage_key": "property/6286356741357568/019d01a4-3355-740f-8d8b-ce1ebfaebc4b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "SLC Apartments Near Central Pointe Station",
      "seo_description": "Explore The Ritz Classic for South Salt Lake City apartments near Central Pointe Station. Enjoy urban living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5756"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9402128683"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NRJ3VBK4"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjI2aVpoUno5dDJEclpaWVBGbklpK2c9PSIsInZhbHVlIjoiZUdZWlAweGtCNENPdEJ3a2YxOFhxQT09IiwibWFjIjoiNTBiOGExOTI3NTlkM2NlMGNjZmQ2Yzc1OGViMTllMDIyOWYwZmI0MWVkNTYzMTBkNmNlNzM3MTcwNDNiNjEzYyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "5756",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9402128683",
  "custom_google_gtm_id": "GTM-NRJ3VBK4",
  "custom_rollout_phase": "Phase 6",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjI2aVpoUno5dDJEclpaWVBGbklpK2c9PSIsInZhbHVlIjoiZUdZWlAweGtCNENPdEJ3a2YxOFhxQT09IiwibWFjIjoiNTBiOGExOTI3NTlkM2NlMGNjZmQ2Yzc1OGViMTllMDIyOWYwZmI0MWVkNTYzMTBkNmNlNzM3MTcwNDNiNjEzYyJ9",
  "custom_audioeye_site_id": "07909db7-4ebe-4331-8347-0382c5344b3d",
  "custom_audioeye_site_hash": "f335e6c4d830ebbd76f10a0d24abb359"
};

export const generatedAt = '2026-11-03T22:52:20.961Z';
